<template>
  <div>
    <!--面包屑导航区域-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--面包屑导航区域-->
    <!--卡片视图区-->
    <el-card>
      <!--搜索与添加区域-->
      <el-row :gutter="20">
        <el-col :span="20">
          <el-input
            placeholder="请输入查询内容"
            clearable
            v-model="queryInfo.query"
            @clear="getOrderList()"
            style="width: 300px"
          >
            <el-select
              slot="prepend"
              v-model="queryInfo.queryType"
              placeholder="选择"
              style="width: 110px"
            >
              <el-option label="用户名" value="username"></el-option>
              <el-option label="卡名" value="cardname"></el-option>
              <el-option label="订单编号" value="orderno"></el-option>
            </el-select>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getOrderList()"
            ></el-button>
          </el-input>
          <el-select
            v-model="queryInfo.query1"
            placeholder="请选择门店"
            @change="handleStoreChange"
            style="margin-left: 10px"
            clearable
            filterable
          >
            <el-option
              v-for="item in storelist"
              :key="item.id"
              :label="item.storename"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-date-picker
            v-model="customdate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="CustomeDate"
            style="margin: 0 10px"
          >
          </el-date-picker>
          <el-select
            v-model="queryInfo.query2"
            clearable
            placeholder="请选择交易类型"
            @change="getOrderList()"
            style="width: 150px"
          >
            <el-option label="平台" value="0"></el-option>
            <el-option label="抖音" value="1"></el-option>
            <el-option label="美团" value="2"></el-option>
            <el-option label="高德" value="7"></el-option>
            <el-option label="赠送" value="3"></el-option>
            <el-option label="分享" value="4"></el-option>
            <el-option label="异业" value="5"></el-option>
            <el-option label="复制" value="6"></el-option>
          </el-select>
          <el-select
            v-model="queryInfo.cardids"
            clearable
            :disabled="!queryInfo.query1"
            placeholder="卡类型（需先选门店）"
            @change="getOrderList()"
            style="margin: 0 10px; width: 180px"
          >
            <el-option
              v-for="item in cardClassOptions"
              :key="item.cardclassid"
              :label="item.label"
              :value="item.cardIds"
            ></el-option>
          </el-select>
          <el-select
            v-model="queryInfo.query3"
            clearable
            placeholder="是否失效"
            @change="getOrderList()"
            style="margin: 0 10px; width: 150px"
          >
            <el-option label="有效" value="0"></el-option>
            <el-option label="失效" value="1"></el-option>
          </el-select>
          <el-select
            v-model="queryInfo.query4"
            clearable
            placeholder="是否退款"
            @change="getOrderList()"
            style="margin: 0 10px; width: 150px"
          >
            <el-option label="正常" value="0"></el-option>
            <el-option label="退款" value="1"></el-option>
          </el-select>
          <el-select
            v-model="queryInfo.doutuiflag"
            clearable
            placeholder="申请退款搜索"
            @change="getOrderList()"
            style="margin: 0 10px; width: 150px"
          >
            <el-option label="申请退款订单" value="1"></el-option>
          </el-select>
          <el-input
            placeholder="抖音/美团/高德券码搜索"
            clearable
            v-model="queryInfo.extra"
            @clear="getOrderList()"
            style="width: 300px"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getOrderList()"
            ></el-button>
          </el-input>
          <!-- <el-input  v-model="queryInfo.extra" clearable  placeholder="抖音/美团券码搜索" @change="getOrderList()"  style="margin: 0 10px;width:150px">
                    </el-input> -->
          <el-button
            type="danger"
            icon="el-icon-present"
            @click="GiftCard"
            v-permission="'btn:order:gift'"
            >手动发卡</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-present"
            @click="showBatchGiftCardDialog"
            v-permission="'btn:order:gift:batch'"
            style="margin-left: 10px"
            >手动批量发卡</el-button
          >
          <el-button
            type="info"
            icon="el-icon-search"
            @click="showGiftCardRecords"
            v-permission="'btn:order:gift'"
            style="margin-left: 10px"
            >查询赠卡记录</el-button
          >
          <el-button
              type="primary"
              icon="el-icon-upload"
              @click="synCard"
              :loading="synLoading"
              v-permission="'btn:order:syncard'"
          >同步会员卡</el-button
          >
        </el-col>
        <el-col :span="4" style="text-align: right">
          <el-button
            type="primary"
            icon="el-icon-upload"
            @click="exportOrders"
            :loading="exporting"
            v-permission="'btn:order:export'"
            >导出Excel</el-button
          >
          <!--                  <el-button type="primary" icon="el-icon-upload" @click="exportOrders2" :loading="exporting" v-permission="'btn:order:export'">导出退款Excel</el-button>-->
        </el-col>
      </el-row>
      <br />
      <!--搜索与添加区域-->
      <!--用户列表区域-->
      <el-table
        :data="orderlist"
        style="width: 100%"
        ref="invoiceTable"
        stripe
        size="small"
        height="760"
        :summary-method="getSummaries"
        show-summary
        v-loading="isLoading"
        :row-class-name="tableRowClassName"
        :row-key="row => row.id"
      >
        <!-- <el-table-column label="ID" type="index"  width="50" fixed></el-table-column> -->
        <el-table-column label="序号" width="50" fixed>
          <template slot-scope="scope">
            {{
              (queryInfo.pagenum - 1) * queryInfo.pagesize + scope.$index + 1
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="订单编号"
          prop="orderno"
          min-width="110"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="用户名"
          prop="username"
          min-width="100"
        ></el-table-column>
        <el-table-column
          label="店铺名"
          prop="storename"
          min-width="90"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- <el-table-column label="卡名" prop="cardname" width="150" :show-overflow-tooltip="true"></el-table-column> -->
        <el-table-column
          label="卡名"
          prop="cardname"
          min-width="120"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="金额"
          prop="amount"
          min-width="60"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope" v-if="scope.row.amount">
            <span style="color: #ff0000">￥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="退款金额"
          prop="refundamount"
          min-width="70"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span style="color: #1989fa" v-if="scope.row.refundamount"
              >￥{{ scope.row.refundamount }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="结算金额"
          prop="owneramount"
          min-width="70"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span style="color: #1989fa" v-if="scope.row.owneramount"
              >￥{{ scope.row.owneramount }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          label="来源"
          prop="cardfrom"
          min-width="140"
        >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.cardfrom == '0'"
              >平台</el-tag
            >
            <el-tag type="danger" v-if="scope.row.cardfrom == '1'">抖音</el-tag>
            <el-tag type="warning" v-if="scope.row.cardfrom == '2'">美团</el-tag>
            <el-tag v-if="scope.row.cardfrom == '7'" style="background-color:#009DFF;border-color:#009DFF;color:#fff;">高德</el-tag>
            <span
              v-if="scope.row.cardfrom == '1' || scope.row.cardfrom == '2' || scope.row.cardfrom == '7'"
              style="padding-left: 10px"
              >劵码：</span>
            <div v-if="scope.row.cardfrom == '1' || scope.row.cardfrom == '2' || scope.row.cardfrom == '7'">
              {{ scope.row.extra }}
            </div>
            <el-tooltip
              v-if="scope.row.cardfrom == '3'"
              :content="scope.row.cardDescribe || '无赠卡原因说明'"
              placement="top"
              effect="dark"
            >
              <el-tag type="primary" style="cursor: help">赠送</el-tag>
            </el-tooltip>
            <el-tag type="info" v-if="scope.row.cardfrom == '4'">分享</el-tag>
            <el-tag type="info" v-if="scope.row.cardfrom == '5'" effect="dark">异业</el-tag>
            <el-tag type="info" v-if="scope.row.cardfrom == '6'">复制</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="开始时间" prop="starttime" width="150"></el-table-column> -->
        <el-table-column
          label="收款商户"
          prop="mchid"
          min-width="80"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          label="状态"
          prop="status"
          min-width="60"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag
              type="success"
              v-if="scope.row.status == '0'"
              style="cursor: pointer"
              @click="toggleOrderStatus(scope.row)"
              v-permission="'btn:order:valid-status'"
              >有效</el-tag>
            <el-tag
              type="info"
              v-if="scope.row.status == '1'"
              style="cursor: pointer"
              @click="toggleOrderStatus(scope.row)"
              v-permission="'btn:order:valid-status'"
              >失效</el-tag>
            <el-tag
              type="info"
              v-if="scope.row.status == '2'"
              style="cursor: pointer"
              v-permission="'btn:order:valid-status'"
              >停卡</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="退款状态"
          min-width="80"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.istuikuan == 1">
              <el-tag
                  type="danger"
              >已退款</el-tag>
            </span>
            <span v-else-if="scope.row.refundFq == '1'">
              <el-tag
                  type="danger"
              >已发起退款</el-tag>
            </span>
              <el-tag
                type="warning"
                v-if="(scope.row.cardfrom == '1' || scope.row.cardfrom == '2' || scope.row.cardfrom == '7')  && scope.row.istuikuan == 0"
                style="cursor: pointer"
                @click="markRefund(scope.row)"
              >标记退款</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="分账状态"
          min-width="80"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.fzStatus == 'PROCESSING' || scope.row.fzStatus == 'PENDING_RETRY' || scope.row.fzStatus == 'RELOAD'">
              <el-tag
                  type="primary"
              >分账中</el-tag>
            </span>
            <span v-else-if="scope.row.fzStatus == 'ERROR' || scope.row.fzStatus == 'ERROR_JD' || scope.row.fzStatus == 'JD_ERROR'">
              <el-tag
                  type="danger"
              >分账失败</el-tag>
            </span>
            <span v-else-if="scope.row.fzStatus == 'FINISHED'">
              <el-tag
                  type="success"
              >分账成功</el-tag>
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="分账失败原因"
          min-width="80"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.fzStatus == 'ERROR' || scope.row.fzStatus == 'ERROR_JD' || scope.row.fzStatus == 'JD_ERROR'">
              {{scope.row.fzError}}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="开始时间"
          prop="starttime"
          min-width="110"
        >
          <template slot-scope="scope">
            {{scope.row.starttime.slice(2)}}
          </template>
        </el-table-column>
        <el-table-column
          label="截止时间"
          prop="endtime"
          min-width="110"
        >
          <template slot-scope="scope">
            {{scope.row.endtime.slice(2)}}
          </template>
        </el-table-column>
        <el-table-column
          label="订单日期"
          prop="adddate"
          min-width="110"
        >
          <template slot-scope="scope">
            {{scope.row.adddate.slice(2)}}
          </template>
        </el-table-column>
        <el-table-column
          label="退款日期"
          prop="refundDateStr"
          min-width="110"
        >
          <template slot-scope="scope">
            {{scope.row.refundDateStr?.slice(2)}}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="240" >
          <template slot-scope="scope">
            <span v-if="scope.row.cardfrom == 0 || scope.row.cardfrom == 1 || scope.row.cardfrom == 2 || scope.row.cardfrom == 7">
              <el-button type="primary" v-if="scope.row.status == 0 && scope.row.istong == 0"
                  icon="el-icon-copy-document" size="mini" @click="CopyCard(scope.row)" v-permission="'btn:order:copy'">复制卡</el-button>
              <!-- 取消标记退款按钮 -->
              <el-button
                v-if="scope.row.istuikuan == 1 && scope.row.status == 1 && (scope.row.refundamount == null || scope.row.refundamount == 0) && scope.row.cardfrom != 0"
                type="info" icon="el-icon-refresh-left" size="mini"
                @click="handleCancelMarkRefund(scope.row)"
                v-permission="'btn:order:cancel-mark-refund'">取消标记退款</el-button>
            </span>
            <el-button
                v-if="scope.row.amount > 0 && scope.row.refundFq == '0' &&
                  (
                      (scope.row.doutuiflag == 0 && scope.row.istuikuan == 0) ||
                      (scope.row.cardfrom == 0 && parseFloat(scope.row.refundamount ? scope.row.refundamount : '0') < parseFloat(scope.row.amount))
                  )"
                type="warning" icon="el-icon-delete" size="mini"
                @click="DelCard(scope.row)"
                v-permission="'btn:order:delete'">退款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--用户列表区域-->
      <!--分页区域-->
      <br />
      <div align="center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pagenum"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="queryInfo.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[1, 5, 10, 20, 50, 100]"  :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination> -->
      </div>
    </el-card>
    <!--发卡对话框-->
    <el-dialog
      title="发放时效卡"
      :visible.sync="giftDialogVisible"
      width="50%"
      @close="giftDialogClosed"
      custom-class="gift-card-dialog"
    >
      <el-form
        :model="giftForm"
        :rules="giftFormRules"
        ref="giftFormRef"
        label-width="100px"
      >
        <el-form-item label="手机号" prop="phone">
          <div style="display: flex; align-items: center; gap: 10px;">
            <el-input
              v-model="giftForm.phone"
              placeholder="请输入手机号"
              style="width: 70%"
              @input="onPhoneInput"
              @blur="checkPhoneStatus"
            >
            </el-input>
            <el-button
              v-if="phoneStatus && !phoneStatus.isMultiple && phoneStatus.isRegistered"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="queryUserCards"
              :loading="userCardsLoading"
            >
              查看会员卡
            </el-button>
          </div>
          <!-- 状态提示区域 -->
          <div
            v-if="phoneStatus"
            class="phone-status-tip"
            style="margin-top: 8px"
          >
            <!-- 单个手机号显示 -->
            <div v-if="!phoneStatus.isMultiple">
              <el-tag
                v-if="phoneStatus.isRegistered"
                type="success"
                size="mini"
                icon="el-icon-check"
              >
                ✓ 已注册用户（{{ phoneStatus.username }}）
              </el-tag>
              <el-tag v-else type="warning" size="mini" icon="el-icon-warning">
                ⚠ 未注册用户（将创建赠卡记录）
              </el-tag>
            </div>

            <!-- 多个手机号显示 -->
            <div v-else>
              <div style="margin-bottom: 8px;">
                <el-tag type="info" size="mini" icon="el-icon-phone">
                  共{{ phoneStatus.phones.length }}个手机号
                </el-tag>
                <el-tag
                  v-if="phoneStatus.registeredCount > 0"
                  type="success"
                  size="mini"
                  style="margin-left: 5px;"
                >
                  {{ phoneStatus.registeredCount }}个已注册
                </el-tag>
                <el-tag
                  v-if="phoneStatus.unregisteredCount > 0"
                  type="warning"
                  size="mini"
                  style="margin-left: 5px;"
                >
                  {{ phoneStatus.unregisteredCount }}个未注册
                </el-tag>
              </div>

              <!-- 详细状态列表 -->
              <div style="max-height: 120px; overflow-y: auto;">
                <div
                  v-for="phone in phoneStatus.phones"
                  :key="phone.phone"
                  style="margin-bottom: 4px;"
                >
                  <el-tag
                    :type="phone.isRegistered ? 'success' : 'warning'"
                    size="mini"
                    style="margin-right: 5px; min-width: 60px;"
                  >
                    {{ phone.phone }}
                  </el-tag>
                  <span style="font-size: 12px; color: #666;">
                    {{ phone.isRegistered ? `已注册(${phone.username})` : '未注册' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="phoneCheckLoading"
            style="margin-top: 8px; color: #999; font-size: 12px"
          >
            <i class="el-icon-loading"></i> 正在检查手机号状态...
          </div>

          <!-- 用户会员卡展示区域 -->
          <div v-if="userCards && userCards.length > 0" style="margin-top: 12px;">
            <div style="font-size: 13px; color: #666; margin-bottom: 8px; font-weight: 500;">
              <i class="el-icon-postcard"></i> 用户现有会员卡（{{ userCards.length }}张）
            </div>
            <div style="max-height: 200px; overflow-y: auto; border: 1px solid #e4e7ed; border-radius: 4px; padding: 8px;">
              <div
                v-for="card in userCards"
                :key="card.id"
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 8px 12px;
                  margin-bottom: 6px;
                  background: #f8f9fa;
                  border-radius: 4px;
                  border-left: 3px solid #409eff;
                "
              >
                <div style="flex: 1;">
                  <div style="font-weight: 500; color: #303133; margin-bottom: 2px;">
                    {{ card.cardname }}
                    <span style="font-size: 12px; color: #909399; margin-left: 8px;">
                      ({{ card.storename || '未知店铺' }})
                    </span>
                  </div>
                  <div style="font-size: 12px; color: #606266;">
                    购买时间：{{ card.adddate }} |
                    有效期：{{ card.starttime }} ~ {{ card.endtime }}
                    <span v-if="card.remainingDays > 0" style="color: #67c23a; margin-left: 8px;">
                      剩余{{ card.remainingDays }}天
                    </span>
                  </div>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <el-tag
                    :type="card.isValid ? 'success' : 'danger'"
                    size="mini"
                  >
                   {{ card.status === 0 ? '有效' : '无效' }}
                  </el-tag>
                  <el-tag
                    :type="card.paytus == 1 ? 'success' : 'warning'"
                    size="mini"
                  >
                    {{ card.paytus == 1 ? '已支付' : '未支付' }}
                  </el-tag>
                  <span style="font-weight: 500; color: #f56c6c;">¥{{ card.amount }}</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="userCardsLoading" style="margin-top: 8px; color: #999; font-size: 12px;">
            <i class="el-icon-loading"></i> 正在查询用户会员卡...
          </div>
        </el-form-item>
        <!-- <el-form-item label="类型" prop="type">
          <el-radio-group v-model="giftForm.type" @change="handleTypeAlter">
            <el-radio :label="'0'">按卡发放</el-radio>
            <el-radio :label="'1'">按时长发放</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <input type="hidden" v-model="giftForm.type" value="0" />
        <el-form-item label="发卡门店" prop="storeid">
          <el-select
            filterable
            multiple
            v-model="giftForm.storeid"
            @change="handleStoreAlter"
            placeholder="请选择门店（可多选）"
            style="width: 80%"
          >
            <el-option
              v-for="item in stores"
              :key="item.id"
              :label="item.storename"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <!-- 多门店选择提示 -->
          <div v-if="Array.isArray(giftForm.storeid) && giftForm.storeid.length > 1" style="margin-top: 5px;">
            <el-tag type="warning" size="mini">已选 {{ giftForm.storeid.length }} 个门店，会员卡仅可选择"其他时效卡"</el-tag>
          </div>

          <!-- 门店开业时间提示 -->
          <div v-if="storeOpeningInfo" style="margin-top: 10px;">
            <el-alert
              v-if="storeOpeningInfo.overOneMonth"
              :title="`⚠️ 该门店已开业 ${storeOpeningInfo.daysSinceOpening} 天`"
              type="warning"
              :closable="false"
              show-icon
            >
              <template slot>
                <div style="font-size: 13px; line-height: 1.6;">
                  <div><strong>开业日期：</strong>{{ storeOpeningInfo.openingDate }}</div>
                  <div style="color: #e6a23c; font-weight: 500; margin-top: 4px;">
                    ⚠️ 已超过一个月，请谨慎发放时效卡！
                  </div>
                </div>
              </template>
            </el-alert>
            <el-alert
              v-else
              :title="`该门店已开业 ${storeOpeningInfo.daysSinceOpening} 天`"
              type="info"
              :closable="false"
            >
              <template slot>
                <div style="font-size: 13px;">
                  <span>开业日期：{{ storeOpeningInfo.openingDate }}</span>
                  <span style="margin-left: 10px; color: #67c23a;">
                    距离一个月还有 {{ storeOpeningInfo.daysUntilOneMonth }} 天
                  </span>
                </div>
              </template>
            </el-alert>
          </div>

          <div v-if="storeOpeningLoading" style="margin-top: 8px; color: #999; font-size: 12px;">
            <i class="el-icon-loading"></i> 正在获取门店开业时间...
          </div>
        </el-form-item>
        <el-form-item label="卡类型" prop="cardType">
          <el-radio-group v-model="giftForm.cardType" @change="handleCardTypeChange">
            <el-radio label="time">时间卡</el-radio>
            <el-radio v-if="!(Array.isArray(giftForm.storeid) && giftForm.storeid.length > 1)" label="city">城市通卡</el-radio>
            <el-radio v-if="!(Array.isArray(giftForm.storeid) && giftForm.storeid.length > 1)" label="national">全国通卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会员卡" prop="cardid">
          <el-select
            v-model="giftForm.cardid"
            filterable
            placeholder="请选择会员卡（可输入搜索）"
            style="width: 80%"
            @change="handleCardChange"
            default-first-option
          >
            <el-option
              v-for="item in displayCards"
              :key="item.id"
              :value="item.id"
              :label="item.cardname"
              :class="{'other-time-card': item.id === 'other_time_card'}"
            >
              <div style="display: flex; justify-content: space-between; align-items: center">
                <span>{{ item.cardname }}</span>
                <div style="font-size: 12px; color: #999; margin-left: 10px">
                  <span v-if="item.days" style="margin-right: 8px">{{ item.days }}天</span>
                  <span v-if="item.price" style="margin-right: 8px; color: #f56c6c">¥{{ item.price }}</span>
                  <el-tag v-if="item.isActive !== undefined" :type="item.isActive ? 'success' : 'danger'" size="mini">
                    {{ item.isActive ? '启用' : '禁用' }}
                  </el-tag>
                </div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生效日期" prop="startDate" v-if="giftForm.storeid.length <= 1">
          <el-date-picker
              v-model="giftForm.startDate"
              style="width: 100%"
              align="right"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              clearable
              :picker-options="sendPickerOptions">
          </el-date-picker>
        </el-form-item>
        <!-- 城市通卡时显示城市选择 -->
        <el-form-item label="选择城市" prop="cityScope" v-if="giftForm.cardType === 'city'">
          <el-select
            v-model="giftForm.cityScope"
            multiple
            filterable
            collapse-tags
            placeholder="输入城市名搜索，可多选"
            style="width: 80%"
            @change="handleCityScopeChange"
          >
            <el-option
              v-for="item in cityListWithCount"
              :key="item.city"
              :label="item.city"
              :value="item.city"
            >
              <span>{{ item.city }}</span>
              <span style="float: right; color: #8492a6; font-size: 12px">{{ item.count }}家店铺</span>
            </el-option>
          </el-select>
          <div style="font-size: 12px; color: #909399; margin-top: 5px" v-if="giftForm.cityScope.length > 0">
            已选 {{ giftForm.cityScope.length }} 个城市，共 {{ selectedCityStoreCount }} 家店铺
          </div>
        </el-form-item>
        <!-- 城市通卡时显示排除门店选择 -->
        <el-form-item label="排除门店" v-if="giftForm.cardType === 'city' && giftForm.cityScope.length > 0">
          <el-select
            v-model="giftForm.excludeStores"
            multiple
            filterable
            collapse-tags
            placeholder="可选择要排除的门店（不选则全部门店可用）"
            style="width: 80%"
          >
            <el-option
              v-for="store in selectedCityStores"
              :key="store.id"
              :label="store.storename"
              :value="store.id"
            >
              <span>{{ store.storename }}</span>
              <span style="float: right; color: #8492a6; font-size: 12px">{{ store.city }}</span>
            </el-option>
          </el-select>
          <div style="font-size: 12px; color: #909399; margin-top: 5px" v-if="giftForm.excludeStores.length > 0">
            已排除 {{ giftForm.excludeStores.length }} 家门店
          </div>
        </el-form-item>
        <!-- 根据卡类型动态设置istong值 -->
        <el-form-item label="发放时长" prop="days" v-if="giftForm.cardid === 'other_time_card'">
          <el-input
            placeholder="请输入时长"
            v-model="giftForm.days"
            style="width: 80%"
            class="duration-input"
          >
            <template slot="append">天</template>
          </el-input>
        </el-form-item>
        <el-form-item label="发卡原因" prop="cardDescribe">
          <div style="width: 80%">
            <!-- 常用短语选择 -->
            <div style="margin-bottom: 10px">
              <span style="font-size: 12px; color: #666; margin-right: 10px">常用短语：</span>
              <el-button
                v-for="phrase in commonPhrases"
                :key="phrase"
                type="text"
                size="mini"
                @click="selectPhrase(phrase)"
                style="margin-right: 5px; margin-bottom: 5px; padding: 2px 8px; border: 1px solid #ddd; border-radius: 3px"
              >
                {{ phrase }}
              </el-button>
            </div>
            <el-input
              type="textarea"
              v-model="giftForm.cardDescribe"
              placeholder="请输入发卡原因，或点击上方常用短语快速选择"
              :rows="3"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </div>
        </el-form-item>
        <!-- <el-form-item label="赠送数量" prop="quantity">
                            <el-input-number v-model="giftForm.quantity" :min="1" :max="10" label="描述文字"></el-input-number>
                        </el-form-item> -->
        <!-- <el-form-item label="备注" prop="remark">
                            <el-input type="textarea" v-model="giftForm.remark" placeholder="此备注内容会以系统消息的方式发给客户。如：***赠送月卡一张。" style="width: 80%;"></el-input>
                        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="giftDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="SaveGiftCard"
          :loading="giftLoading"
          icon="el-icon-s-promotion"
          >发卡</el-button
        >
      </span>
    </el-dialog>
    <!--发卡对话框-->

    <!--批量发卡对话框-->
    <el-dialog
      title="批量发卡"
      :visible.sync="batchGiftDialogVisible"
      width="50%"
      @close="batchGiftDialogClosed"
      custom-class="gift-card-dialog"
    >
      <el-form
        :model="batchGiftForm"
        :rules="batchGiftFormRules"
        ref="batchGiftFormRef"
        label-width="100px"
      >
        <el-form-item label="发卡门店" prop="storeid">
          <el-select
            filterable
            v-model="batchGiftForm.storeid"
            @change="handleBatchStoreChange"
            placeholder="请选择门店"
            style="width: 80%"
          >
            <el-option
              v-for="item in stores"
              :key="item.id"
              :label="item.storename"
              :value="item.id"
            >
            </el-option>
          </el-select>

          <!-- 门店开业时间提示 -->
          <div v-if="batchStoreOpeningInfo" style="margin-top: 10px;">
            <el-alert
              v-if="batchStoreOpeningInfo.overOneMonth"
              :title="`⚠️ 该门店已开业 ${batchStoreOpeningInfo.daysSinceOpening} 天`"
              type="warning"
              :closable="false"
              show-icon
            >
              <template slot>
                <div style="font-size: 13px; line-height: 1.6;">
                  <div><strong>开业日期：</strong>{{ batchStoreOpeningInfo.openingDate }}</div>
                  <div style="color: #e6a23c; font-weight: 500; margin-top: 4px;">
                    ⚠️ 已超过一个月，请谨慎发放时效卡！
                  </div>
                </div>
              </template>
            </el-alert>
            <el-alert
              v-else
              :title="`该门店已开业 ${batchStoreOpeningInfo.daysSinceOpening} 天`"
              type="info"
              :closable="false"
            >
              <template slot>
                <div style="font-size: 13px;">
                  <span>开业日期：{{ batchStoreOpeningInfo.openingDate }}</span>
                  <span style="margin-left: 10px; color: #67c23a;">
                    距离一个月还有 {{ batchStoreOpeningInfo.daysUntilOneMonth }} 天
                  </span>
                </div>
              </template>
            </el-alert>
          </div>

          <div v-if="batchStoreOpeningLoading" style="margin-top: 8px; color: #999; font-size: 12px;">
            <i class="el-icon-loading"></i> 正在获取门店开业时间...
          </div>
        </el-form-item>
        <el-form-item label="导入文件" prop="file" required>
          <el-upload
            ref="batchUpload"
            :auto-upload="false"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :file-list="batchGiftForm.fileList"
            :limit="1"
            accept=".xls,.xlsx"
            action="#"
          >
            <el-button size="small" type="primary" icon="el-icon-upload">选择文件</el-button>
            <el-button
              size="small"
              type="success"
              icon="el-icon-download"
              @click.stop="downloadTemplate"
              style="margin-left: 10px"
            >下载模板</el-button>
            <div slot="tip" class="el-upload__tip">
              只支持 .xls 或 .xlsx 格式的Excel文件
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchGiftDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitBatchGiftCard"
          :loading="batchGiftLoading"
          icon="el-icon-s-promotion"
        >批量发卡</el-button>
      </span>
    </el-dialog>
    <!--批量发卡对话框-->

    <!--退款对话框-->
    <el-dialog
      title="退款"
      :visible.sync="refundDialogVisible"
      width="65%"
      @close="refundDialogClosed"
    >
      <el-alert
        v-if="refundLinkInfo"
        type="warning"
        :closable="false"
        style="margin-bottom: 20px"
      >
        <div slot="title">
          <div style="margin-bottom: 8px">
            <strong>是否直接退款：</strong>
            <span>{{ Number(refundLinkInfo.isDirectRefund) === 1 ? '是' : '否' }}</span>
          </div>
          <div
            v-if="refundLinkContactText(refundLinkInfo)"
            style="margin-bottom: 8px"
          >
            <strong>退款联系人：</strong>
            <span>{{ refundLinkContactText(refundLinkInfo) }}</span>
          </div>
          <div v-if="refundLinkInfo.remark">
            <strong>备注：</strong>
            <span>{{ refundLinkInfo.remark }}</span>
          </div>
        </div>
      </el-alert>
      <div class="reFoundContainer">
        <div class="label">退款类型</div>
        <el-radio-group v-model="refundType" @change="handleRefund">
          <el-radio :label="0">发送退款</el-radio>
          <el-radio :label="1">直接退款</el-radio>
        </el-radio-group>
      </div>
      <el-row :gutter="20">
        <el-form
            :model="refundForm"
            :rules="refundFormRules"
            ref="refundFormRef"
            label-width="100px">
          <!-- 左侧：退款表单 -->
          <el-col :span="12">
              <el-form-item label="订单金额" prop="amount">
                {{ refundForm.amount }} 元
              </el-form-item>
              <el-form-item label="剩余可退金额" prop="syAmount">
                {{ refundForm.syAmount }} 元
              </el-form-item>
              <el-form-item label="退款金额" prop="refundamount">
                <div v-if="refundType == 1">
                  <el-input
                      v-model="refundForm.refundamount"
                      placeholder="请输入退款金额"
                      style="width: 200px; margin-right: 10px"
                      @input="validateRefundAmount"
                      @keypress="checkNumberInput"
                      @paste="handlePaste"
                      @compositionend="handleCompositionEnd"
                      type="text"
                      :disabled="refundForm.cardfrom == '1' || refundForm.cardfrom == '2' || refundForm.cardfrom == '7'"
                  ></el-input>
                  元
                  <span
                      v-if="refundForm.cardfrom == '1' || refundForm.cardfrom == '2' || refundForm.cardfrom == '7'"
                      style="color: #e6a23c; font-size: 12px">
                      (抖音/美团/高德订单退款金额固定为订单金额)
                  </span>
                </div>
                <div v-else>
                  {{refundForm.refundamount}} 元
                </div>
              </el-form-item>
              <el-form-item label="退款说明" prop="refunddescribe">
                <el-input
                  type="textarea"
                  v-model="refundForm.refunddescribe"
                  placeholder="请输入退款说明"
                  :rows="3"
                ></el-input>
              </el-form-item>
              <!-- 客服拒绝原因填写框 -->
              <el-form-item
                label="拒绝原因"
                v-if="refundForm.cardfrom == 1"
                prop="rejectreason"
              >
                <el-input
                  type="textarea"
                  v-model="refundForm.rejectreason"
                  placeholder="请输入拒绝退款的原因"
                  :rows="3"
                ></el-input>
              </el-form-item>
              <!-- 显示抖音退款原因 -->
              <el-form-item label="客服退卡原因" v-if="refundForm.doutuireason">
                <span style="color: #f56c6c">{{ refundForm.doutuireason }}</span>
              </el-form-item>
          </el-col>
          <!-- 右侧：到店天数与费用计算 -->
          <el-col :span="12">
            <div style="border-left: 1px solid #ebeef5; padding-left: 20px;">
              <h4 style="margin-top: 0; margin-bottom: 15px; color: #303133;">到店消费计算</h4>
              <div v-if="visitDaysLoading" style="text-align: center; padding: 20px;">
                <i class="el-icon-loading"></i> 正在查询到店记录...
              </div>
              <div v-else>
                <div style="margin-bottom: 12px; font-size: 14px; color: #606266;">
                  <span>卡有效期：</span>
                  <span style="color: #303133;">{{ refundForm.starttime || '-' }} 至 {{ refundForm.endtime || '-' }}</span>
                </div>
                <div style="margin-bottom: 12px; font-size: 14px; color: #606266;" v-if="refundForm.endtime">
                  <span>开卡天数：</span>
                  <span style="color: #e6a23c; font-weight: bold; font-size: 18px;">{{ refundForm.openDays }}</span>
                  <span> 天</span>
                </div>
                <div style="margin-bottom: 12px; font-size: 14px; color: #606266;">
                  <span>到店天数：</span>
                  <span style="color: #e6a23c; font-weight: bold; font-size: 18px;">{{ visitDaysInfo.visitDays || 0 }}</span>
                  <span> 天</span>
                  <el-button
                    v-if="visitDaysInfo.visitDays > 0"
                    type="text"
                    size="mini"
                    @click="visitDaysInfo.showDetails = !visitDaysInfo.showDetails"
                    style="margin-left: 8px;"
                  >{{ visitDaysInfo.showDetails ? '收起详情' : '查看详情' }}</el-button>
                </div>
                <!-- 到店详情列表 -->
                <div v-if="visitDaysInfo.showDetails && visitDaysInfo.details && visitDaysInfo.details.length > 0" style="max-height: 300px; overflow-y: auto; margin-bottom: 12px; border: 1px solid #ebeef5; border-radius: 4px;">
                  <div
                    v-for="(day, index) in visitDaysInfo.details"
                    :key="index"
                    style="padding: 8px 12px; border-bottom: 1px solid #f0f0f0;"
                    :style="{ background: index % 2 === 0 ? '#fafafa' : '#fff' }"
                  >
                    <div style="font-weight: bold; color: #303133; margin-bottom: 4px;">{{ day.date }}</div>
                    <div v-for="(rec, rIdx) in day.records" :key="rIdx" style="font-size: 13px; color: #606266; padding-left: 12px;">
                      <el-tag :type="rec.type === 'in' ? 'success' : 'info'" size="mini" style="margin-right: 6px;">{{ rec.type === 'in' ? '进' : '出' }}</el-tag>
                      <span>{{ rec.time }}</span>
                    </div>
                  </div>
                </div>
                <div style="margin-bottom: 12px; font-size: 14px; color: #606266;">
                  <span>每天单价：</span>
                  <el-input v-if="refundType == 1"
                    v-model="visitDaysInfo.unitPrice"
                    placeholder="单价"
                    style="width: 100px;"
                    size="small"
                    @input="calcRefundAmount"
                  ></el-input>
                  <span v-else>
                    {{visitDaysInfo.unitPrice}}
                  </span>
                  <span> 元/天</span>
                </div>
                <el-divider></el-divider>
                <div style="margin-bottom: 12px; font-size: 14px; color: #606266;" v-if="refundType == 1">
                  <span>应收金额：</span>
                  <span style="color: #f56c6c; font-weight: bold; font-size: 16px;">{{ refundForm.shouldCharge || '0.00' }}</span>
                  <span> 元</span>
                  <span style="color: #909399; font-size: 12px; margin-left: 5px;">（{{ refundForm.openDays }}天 × {{ visitDaysInfo.unitPrice || 0 }}元）</span>
                </div>
                <div style="margin-bottom: 12px; font-size: 14px; color: #606266;" v-else>
                  <el-form-item label="应收金额" label-width="80px" prop="shouldCharge">
                    <el-input
                        v-model="refundForm.shouldCharge"
                        placeholder="请输入应收金额"
                        @input="validateShouldAmount"
                        @keypress="checkNumberInputShould"
                        @paste="handlePasteShould"
                        @compositionend="handleCompositionEndShould"
                        style="width: 100px; margin-right: 10px"
                        type="text"></el-input>
                    元
                    <span style="color: #909399; font-size: 12px; margin-left: 5px;">（{{ refundForm.openDays }}天 × {{ visitDaysInfo.unitPrice || 0 }}元）</span>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-col>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDialogVisible = false">取 消</el-button>
        <el-button
          type="danger"
          @click="rejectRefund"
          v-if="refundForm.cardfrom == 1 && refundType == 1"
          >拒绝退款</el-button>
        <el-button type="primary" @click="submitRefund">确定退款</el-button>
      </span>
    </el-dialog>
    <!--退款对话框-->

    <!--赠卡记录查询对话框-->
    <el-dialog
      title="非注册用户赠卡记录"
      :visible.sync="giftRecordDialogVisible"
      width="80%"
      @close="giftRecordDialogClosed"
      custom-class="gift-record-dialog"
    >
      <!-- 搜索区域 -->
      <el-row :gutter="20" style="margin-bottom: 20px">
        <el-col :span="6">
          <el-input
            v-model="giftRecordQuery.receiverPhone"
            placeholder="收卡人手机号"
            clearable
            @clear="getGiftCardRecords"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getGiftCardRecords"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-select
            v-model="giftRecordQuery.storeId"
            placeholder="选择店铺"
            clearable
            @change="getGiftCardRecords"
            filterable
          >
            <el-option
              v-for="item in storelist"
              :key="item.id"
              :label="item.storename"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select
            v-model="giftRecordQuery.isClaimed"
            placeholder="领取状态"
            clearable
            @change="getGiftCardRecords"
          >
            <el-option label="未领取" :value="0"></el-option>
            <el-option label="已领取" :value="1"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="getGiftCardRecords" icon="el-icon-search">搜索</el-button>
          <el-button @click="resetGiftRecordQuery" icon="el-icon-refresh">重置</el-button>
        </el-col>
      </el-row>

      <!-- 表格区域 -->
      <el-table
        :data="giftRecordList"
        style="width: 100%"
        stripe
        size="small"
        v-loading="giftRecordLoading"
        height="400"
      >
        <el-table-column label="序号" width="60" type="index"></el-table-column>
        <el-table-column label="卡号" prop="cardNo" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="卡名" prop="cardName" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="收卡人手机号" prop="receiverPhone" width="120"></el-table-column>
        <el-table-column label="店铺" prop="storeName" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="赠送时间" prop="giftTime" width="150"></el-table-column>
        <el-table-column label="过期时间" prop="expireTime" width="150"></el-table-column>
        <el-table-column label="领取状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="!scope.row.isClaimed || scope.row.isClaimed == 0 || scope.row.isClaimed === false" type="warning" size="mini">未领取</el-tag>
            <el-tag v-else type="success" size="mini">已领取</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 1" type="success" size="mini">有效</el-tag>
            <el-tag v-else type="danger" size="mini">无效</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="deleteGiftCardRecord(scope.row.id)"
              v-if="!scope.row.isClaimed || scope.row.isClaimed == 0 || scope.row.isClaimed === false"
            >删除</el-button>
            <span v-else style="color: #999; font-size: 12px">已领取</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div style="text-align: center; margin-top: 20px">
        <el-pagination
          @size-change="handleGiftRecordSizeChange"
          @current-change="handleGiftRecordCurrentChange"
          :current-page="giftRecordQuery.pagenum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="giftRecordQuery.pagesize"
          layout="total, sizes, prev, pager, next"
          :total="giftRecordTotal"
        >
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="giftRecordDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
    <!--赠卡记录查询对话框-->

    <!--复制卡片对话框-->
    <el-dialog
        title="复制卡片"
        :visible.sync="copyDialogVisible"
        width="40%"
    >
      <el-form
          :model="copyForm"
          :rules="copyFormRules"
          ref="copyFormRef"
          label-width="100px"
      >
        <el-form-item label="门店" prop="storeid">
          <el-select
              v-model="copyForm.storeid"
              placeholder="选择门店"
              clearable
              filterable
          >
            <el-option
                v-for="item in storelist"
                :key="item.id"
                :label="item.storename"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCopy">确 定</el-button>
      </span>
    </el-dialog>
    <!--退款对话框-->
  </div>
</template>
<script>
import axios from "axios";
import {saveAs} from "file-saver";
import {Loading} from "element-ui";

export default {
  data() {
    return {
      refundType: 0,
      copyDialogVisible: false,
      synLoading: false,
      exporting: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      sendPickerOptions: {
        disabledDate(time) {
          const yesterday = new Date()
          yesterday.setDate(yesterday.getDate() - 1)

          return time.getTime() < yesterday;
        }
      },
      customdate: "",
      //获取订单列表的参数对象
      queryInfo: {
        query: "",
        queryType: "username", // 默认查询用户名
        query1: "",
        query2: "",
        query3: "",
        query4: "",
        cardids: "",
        doutuiflag: "",
        extra: "",
        startdate: "",
        enddate: "",
        pagenum: 1,
        pagesize: 20,
      },
      searchChanged: false,
      orderlist: [],
      storelist: [],
      cardClassOptions: [], // 当前门店下的卡类型分组选项（按 cardclassid 分组）
      cardClassMap: { 1: '时间卡', 2: '次卡', 3: '体验卡', 4: '学生卡', 5: '女神卡', 6: '店主卡', 7: '私教卡', 8: '其他', 9: '早鸟卡' },
      total: 0,
      giftDialogVisible: false,
      giftLoading: false, // 发卡加载状态
      refundDialogVisible: false,
      refundLinkInfo: null,
      stopDialogVisible: false,
      giftForm: {
        phone: "", // 手机号输入
        cardid: null, // 不设置默认值，避免显示0
        storeid: [], // 发卡门店（多选，可一个或多个）
        storeidlist: [], // 多门店发卡时的门店ID数组
        remark: "",
        cardDescribe: "", // 发卡原因
        username: [],
        type: "1", // 默认按时长发放
        days: null,
        istong: "0",
        startDate: null,
        cardType: "time", // 卡类型：time=时间卡, city=城市通卡, national=全国通卡
        cityScope: [], // 城市通卡选择的城市列表
        excludeStores: [], // 排除的门店ID列表
      },
      // 常用发卡原因短语
      commonPhrases: [
        "店主通知",
        "失效卡补卡",
        "客服补偿",
        "活动赠送",
        "平台核销",
        "系统调试"
      ],
      // 批量发卡相关
      batchGiftDialogVisible: false,
      batchGiftLoading: false,
      batchGiftForm: {
        storeid: "",
        file: null,
        fileList: []
      },
      batchGiftFormRules: {
        storeid: [{ required: true, message: "请选择发卡门店", trigger: "blur" }],
        file: [{ required: true, message: "请选择导入文件", trigger: "change" }]
      },
      // 批量发卡门店开业时间相关字段
      batchStoreOpeningInfo: null,
      batchStoreOpeningLoading: false,
      // 智能检测相关字段
      phoneStatus: null, // 手机号状态 { phone, isRegistered, username }
      phoneFlag: false, // 手机号状态 { phone, isRegistered, username }
      phoneCheckLoading: false, // 检查加载状态
      phoneCheckTimer: null, // 防抖定时器
      // 用户会员卡相关字段
      userCards: [], // 用户会员卡列表
      userCardsLoading: false, // 查询用户会员卡加载状态
      // 门店开业时间相关字段
      storeOpeningInfo: null, // 门店开业时间信息
      storeOpeningLoading: false, // 查询门店开业时间加载状态
      giftFormRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: this.validatePhone, trigger: "blur" },
        ],
        cardid: [{ required: true, message: "请选择会员卡", trigger: "blur" }],
        cardType: [{ required: true, message: "请选择卡类型", trigger: "change" }],
        storeid: [{ required: true, message: "请选择发卡门店", trigger: "blur" }],
        cardDescribe: [
          { required: true, message: "请输入发卡原因", trigger: "blur" },
          {
            min: 2,
            max: 200,
            message: "发卡原因长度在 2 到 200 个字符",
            trigger: "blur",
          },
        ],
        days: [
          { pattern: /^\d{0,3}$/, message: "最大时长999", trigger: "blur" },
        ],
      },
      refundForm: {
        id: "",
        amount: 0, // 订单金额
        syAmount: 0, //剩余可退金额
        refundamount: "", // 退款金额
        refunddescribe: "", // 退款说明
        cardfrom: "", // 来源
        starttime: "", // 卡开始时间
        endtime: "", // 卡结束时间
        username: "", // 用户手机号
        shouldCharge: 0.00, // 应收金额
        openDays: 0
      },
      // 到店天数相关
      visitDaysInfo: {
        visitDays: 0, // 到店天数
        unitPrice: "19", // 每天单价，默认19元
        details: [], // 每天详细进出记录
        showDetails: false, // 是否展开详情
      },
      visitDaysLoading: false,
      copyForm: {
        id: "",
        storeid: null, // 门店ID
      },
      // 退款表单验证规则
      copyFormRules: {
        storeid: [
          { required: false, message: "请选择门店", trigger: "blur" },
        ],
      },
      // 退款表单验证规则
      refundFormRules: {
        refundamount: [
          { required: true, message: "请输入退款金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请输入退款金额"));
              } else if (isNaN(value)) {
                callback(new Error("退款金额必须是数字"));
              } else if (parseFloat(value) <= 0) {
                callback(new Error("退款金额必须大于0"));
              } else if (
                parseFloat(value) > parseFloat(this.refundForm.amount)
              ) {
                callback(new Error("退款金额不能超过订单金额"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        refunddescribe: [
          { required: false, message: "请输入退款说明", trigger: "blur" },
        ],
        shouldCharge: [
          { required: true, message: "请输入应收金额", trigger: "blur" },
          {validator: (rule, value, callback) => {
            if (value === "") {
              callback(new Error("请输入应收金额"));
            } else if (isNaN(value)) {
              callback(new Error("应收金额必须是数字"));
            } else if (parseFloat(value) <= 0) {
              callback(new Error("应收金额必须大于0"));
            } else if (
                parseFloat(value) > parseFloat(this.refundForm.amount)
            ) {
              callback(new Error("应收金额不能超过订单金额"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        }]
      },

      usernames: [],
      loading: false,
      cards: [],
      copyStores: [],
      stores: [],
      isLoading: true,
      exclelist: [],
      excel_fields: {
        //导出Excel表格的表头设置
        订单编号: {
          field: "orderno",
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        门店名称: "storename",
        用户名: "username",
        卡名: "cardname",
        金额: "amount",
        退款金额: "refundamount",
        来源: "cardfrom",
        劵码: {
          field: "extra",
          callback: (value) => {
            return "&nbsp;" + value;
          },
        },
        是否退款: "istuikuan",
        收款商户: "mchid",
        开始时间: "starttime",
        截止时间: "endtime",
        订单日期: "adddate",
      },
      amount: 0,
      id: "",
      // 赠卡记录查询相关数据
      giftRecordDialogVisible: false,
      giftRecordLoading: false,
      giftRecordList: [],
      giftRecordTotal: 0,
      giftRecordQuery: {
        receiverPhone: "",
        storeId: "",
        isClaimed: "",
        pagenum: 1,
        pagesize: 20,
      },
      username: null,
      storeMap: new Map()
    };
  },
  created() {
    this.username = window.sessionStorage.getItem('username')
    this.getOrderList();
    this.GetStore();
  },
  beforeDestroy() {
    // 组件销毁时清理定时器
    if (this.phoneCheckTimer) {
      clearTimeout(this.phoneCheckTimer);
      this.phoneCheckTimer = null;
    }
  },
  computed: {
    displayCards() {
      // "其他时效卡"选项
      const otherTimeCard = {
        id: "other_time_card",
        cardname: "其他时效卡",
        days: null,
        price: null,
        isActive: true
      };

      // 如果选择全国通卡或城市通卡，只显示"其他时效卡"
      if (this.giftForm.cardType === 'national' || this.giftForm.cardType === 'city') {
        return [otherTimeCard];
      }

      // 选择多个发卡门店时，会员卡只能选择"其他时效卡"
      const storeIds = Array.isArray(this.giftForm.storeid) ? this.giftForm.storeid : [];
      if (storeIds.length > 1) {
        return [otherTimeCard];
      }

      // 时间卡：显示istong=0的卡片 + "其他时效卡"
      let normalCards = this.cards || [];
      normalCards = normalCards.filter(card => card.istong === '0' || card.istong === 0);

      return [otherTimeCard, ...normalCards];
    },
    // 城市列表（带店铺数量）
    cityListWithCount() {
      if (!this.stores || this.stores.length === 0) {
        return [];
      }
      // 统计每个城市的店铺数量
      const cityCount = {};
      this.stores.forEach(store => {
        if (store.city) {
          cityCount[store.city] = (cityCount[store.city] || 0) + 1;
        }
      });
      // 转换为数组并排序
      return Object.keys(cityCount)
        .map(city => ({ city, count: cityCount[city] }))
        .sort((a, b) => b.count - a.count); // 按店铺数量降序排列
    },
    // 已选城市的店铺总数
    selectedCityStoreCount() {
      if (!this.giftForm.cityScope || this.giftForm.cityScope.length === 0) {
        return 0;
      }
      return this.cityListWithCount
        .filter(item => this.giftForm.cityScope.includes(item.city))
        .reduce((sum, item) => sum + item.count, 0);
    },
    // 已选城市的所有门店列表（用于排除门店选择）
    selectedCityStores() {
      if (!this.giftForm.cityScope || this.giftForm.cityScope.length === 0 || !this.stores) {
        return [];
      }
      // 已选发卡门店ID列表
      const storeIds = Array.isArray(this.giftForm.storeid) ? this.giftForm.storeid : (this.giftForm.storeid ? [this.giftForm.storeid] : []);
      // 过滤出已选城市的门店，并排除发卡门店（发卡门店始终可以使用）
      return this.stores.filter(store => {
        // 必须在已选城市内
        if (!this.giftForm.cityScope.includes(store.city)) {
          return false;
        }
        // 排除发卡门店（storeid）
        if (storeIds.includes(store.id)) {
          return false;
        }
        return true;
      });
    },

    // 判断当前用户是否有退款权限（admin 或 客服主管）
    canShowRefundButton() {
      return true;
    }
  },
  watch: {
    'queryInfo.query': function() {
      this.searchChanged = true;
      this.queryInfo.pagenum = 1;
    },
    'queryInfo.extra': function() {
      this.searchChanged = true;
      this.queryInfo.pagenum = 1;
    }
  },
  methods: {
    // 切换订单状态
    async toggleOrderStatus(row) {
      // 记录原始状态
      console.log(
        "切换前 - 订单ID:",
        row,
        "当前状态:",
        row.status,
        "类型:",
        typeof row.status
      );

      // 当前状态是字符串类型，需要转换为数字进行比较
      const currentStatus = parseInt(row.status);
      // 如果当前是有效(0)，则切换为失效(1)；如果当前是失效(1)，则切换为有效(0)
      const newStatus = currentStatus === 0 ? 1 : 0;
      console.log(
        "当前状态数字形式:",
        currentStatus,
        "计算后的新状态:",
        newStatus
      );

      // 如果订单已退款，不允许修改状态
      if (row.istuikuan === "1" || row.istuikuan === 1) {
        this.$message.error("退款订单不允许修改状态");
        return;
      }

      try {
        const confirmResult = await this.$confirm(
          `确定要将订单状态修改为${newStatus === 0 ? "有效" : "失效"}吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        if (confirmResult !== "confirm") return;

        // 记录发送的参数
        const params = {
          id: row.id,
          status: newStatus,
        };

        const { data: res } = await this.$http.post(
          "order/valid-status",
          params
        );
        console.log("发送到后端的参数1111:", res);
        if (res.code === 200) {
          this.$message.success(res.msg);
          // 直接更新当前行的状态显示
          row.status = String(newStatus);
        } else {
          this.$message.error(res.msg || "状态更新失败");
        }
      } catch (error) {
        console.error("更新订单状态错误:", error);
        this.$message.error("更新订单状态失败");
      }
    },
    // 标记美团/抖音订单为已退款
    async markRefund(row) {
      const typeText = row.cardfrom == '1' ? '抖音' : row.cardfrom == '2' ? '美团' : '高德';
      try {
        await this.$confirm(
          `确定要将该${typeText}订单标记为已退款吗？标记后订单将同时失效。`,
          '确认标记退款',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        );

        const { data: res } = await this.$http.post('order/mark-refund', {
          id: row.id,
        });

        if (res.code === 200) {
          this.$message.success('标记退款成功');
          this.getOrderList();
        } else {
          this.$message.error(res.msg || '标记退款失败');
        }
      } catch (e) {
        if (e !== 'cancel') {
          console.error('标记退款失败:', e);
        }
      }
    },
    // 取消标记退款
    async handleCancelMarkRefund(row) {
      const typeText = row.cardfrom == '1' ? '抖音' : row.cardfrom == '2' ? '美团' : '高德';
      try {
        await this.$confirm(
          `确认取消该${typeText}订单的退款标记吗？取消后订单将恢复为正常状态。`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        );

        const { data: res } = await this.$http.post('order/cancel-mark-refund', {
          id: row.id,
        });

        if (res.code === 200) {
          this.$message.success('取消标记退款成功');
          this.getOrderList();
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('取消标记退款失败:', error);
          this.$message.error('操作失败: ' + (error.message || '未知错误'));
        }
      }
    },
    async GetStore() {
      const { data: res } = await this.$http.get("store/");
      if (res.status == 0) {
        this.storelist = res.data;
      }
    },
    // 门店变化：动态加载该门店下的卡列表并按卡类型分组，然后刷新订单列表
    async handleStoreChange(storeId) {
      this.queryInfo.cardids = "";
      this.cardClassOptions = [];
      if (storeId) {
        await this.loadStoreCardClasses(storeId);
      }
      this.getOrderList();
    },
    // 查询门店下的卡列表，按卡类型（cardclassid）分组，选项 value 为该类型下所有 card_price.id 的逗号串
    async loadStoreCardClasses(storeId) {
      try {
        const { data: res } = await this.$http.get("cardsStore/", {
          params: { storeid: storeId },
        });
        if (res.status == 0 && Array.isArray(res.data)) {
          const groupMap = {};
          res.data.forEach((card) => {
            const classId = card.cardclassid;
            if (classId === null || classId === undefined) return;
            if (!groupMap[classId]) {
              groupMap[classId] = {
                cardclassid: classId,
                label: this.cardClassMap[classId] || ("卡类型" + classId),
                cardIds: [],
              };
            }
            // 注意：cardsStore 返回的 id 是 card_price.id，与 mycard_info.cardid 一致
            groupMap[classId].cardIds.push(card.id);
          });
          this.cardClassOptions = Object.values(groupMap).map((g) => ({
            ...g,
            cardIds: g.cardIds.join(","),
          }));
        }
      } catch (e) {
        this.cardClassOptions = [];
      }
    },
    async getOrderList() {
      this.isLoading = true
      this.orderlist = [];
      this.queryInfo.pagenum = 1
      this.searchChanged = false;
      try {
        const { data: res } = await this.$http.get("orderlist/", {
          params: this.queryInfo,
        });

        // 检查响应状态和数据是否存在
        if (res.status == 1) {
          if (res.data.totalCount != null) {
            this.total = res.data.totalCount || 0;
          }

          // 处理订单列表数据
          if (res.data.list && Array.isArray(res.data.list)) {
            const newList = res.data.list.map((v, index) => {
              // 合并字段数据和主键
              const orderItem = { ...v.fields, id: res.data.list[index].pk };

              // 确保退款金额字段正确传递
              if (v.fields && v.fields.refundamount) {
                orderItem.refundamount = v.fields.refundamount;
              }

              return orderItem;
            });
            // 使用 $nextTick 确保 DOM 更新完成后再赋值
            this.$nextTick(() => {
              this.orderlist = newList;
              this.isLoading = false;
            });
          } else {
            this.orderlist = [];
            this.isLoading = false;
          }
        } else {
          // 请求失败或数据格式不正确
          this.total = 0;
          this.orderlist = [];
          this.isLoading = false;
          if (res && res.message) {
            this.$message.error(res.message);
          }
        }
        console.log("订单列表数据:", this.orderlist);
      } catch (error) {
        this.isLoading = false;
        this.total = 0;
        this.orderlist = [];
        console.error("获取订单列表失败:", error);
        this.$message.error("获取订单列表失败");
      }
    },
    async getFyOrderList() {
      this.isLoading = true
      const { data: res } = await this.$http.get("orderlist/", {
        params: this.queryInfo,
      });
      this.isLoading = false
      if (res.status == 1) {
        if (res.data.totalCount != null) {
          this.total = res.data.totalCount || 0;
        }

        // 处理订单列表数据
        this.orderlist = res.data.list.map((v, index) => {
          // 合并字段数据和主键
          const orderItem = { ...v.fields, id: res.data.list[index].pk };

          // 确保退款金额字段正确传递
          if (v.fields.refundamount) {
            orderItem.refundamount = v.fields.refundamount;
          }

          return orderItem;
        });
      }
      this.isLoading = false;
      console.log("订单列表数据:", this.orderlist);
    },
    handleSizeChange(newSize) {
      this.isLoading = true;
      this.queryInfo.pagesize = newSize;
      if (this.searchChanged) {
        this.queryInfo.pagenum = 1;
        this.searchChanged = false;
      }
      this.getFyOrderList();
    },
    handleCurrentChange(newPage) {
      this.isLoading = true;
      if (this.searchChanged) {
        newPage = 1;
        this.searchChanged = false;
      }
      this.queryInfo.pagenum = newPage;
      this.getFyOrderList();
    },
    CopyText(row) {
      var oInput = document.createElement("input");
      oInput.value =
        row.cons_address + " " + row.cons_name + " " + row.cons_telephone;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.className = "oInput";
      oInput.style.display = "none";
      this.$message.success("复制成功！");
    },
    async RevokeOrder(id) {
      const confirmResult = await this.$confirm("是否要撤销此订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);

      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除！");
      }
      const { data: res } = await this.$http.get("orderrevoke/" + id);
      // console.log(res)
      if (res.status === 0) {
        this.$message({ message: "撤销成功！", type: "success" });
      }
      this.getOrderList();
    },
    async DelOrder(id) {
      const confirmResult = await this.$confirm("是否要删除此订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);

      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除！");
      }
      const { data: res } = await this.$http.get("orderdel/" + id);
      // console.log(res)
      if (res.status === 0) {
        this.$message({ message: "删除成功！", type: "success" });
      }
      this.getOrderList();
    },
    CustomeDate() {
      // console.log(this.customdate);
      if (this.customdate == null) {
        this.queryInfo.startdate = "";
        this.queryInfo.enddate = "";
      } else {
        this.queryInfo.startdate = this.customdate[0];
        this.queryInfo.enddate = this.customdate[1];
        this.getExcleData();
      }
      this.getOrderList();
    },
    async getExcleData() {
      const { data: res } = await this.$http.get("orderexclist/", {
        params: this.queryInfo,
      });
      if (res.status == 0) {
        // 只获取原始数据，不进行预处理，留给CheckDate方法处理
        this.exclelist = res.data;
        console.log("getExcleData 获取到原始数据:", this.exclelist);
      }
    },
    giftDialogClosed() {
      this.$refs.giftFormRef.resetFields();
      this.stores = [];
      this.phoneStatus = null;
      this.phoneFlag = false
      // 重置默认值
      this.giftForm.type = "1";
      this.giftForm.cardid = null; // 不设置默认值，避免显示0
      this.giftForm.istong = "0";
      this.giftForm.cardType = "time";
      this.giftForm.startDate = null;
    },
    GiftCard() {
      this.giftDialogVisible = true;
      // this.getCards()
      this.getStores();
      this.cards = [];
    },
    // 显示批量发卡对话框
    showBatchGiftCardDialog() {
      this.batchGiftDialogVisible = true;
      this.getStores();
    },
    // 批量发卡对话框关闭
    batchGiftDialogClosed() {
      this.$refs.batchGiftFormRef.resetFields();
      this.batchGiftForm.file = null;
      this.batchGiftForm.fileList = [];
      this.batchStoreOpeningInfo = null;
    },
    // 批量发卡门店选择变化
    async handleBatchStoreChange(storeId) {
      if (!storeId) {
        this.batchStoreOpeningInfo = null;
        return;
      }

      // 获取门店开业时间
      this.batchStoreOpeningLoading = true;
      try {
        const { data: res } = await this.$http.get(`api/store/opening-time/${storeId}`);

        if (res.code === 200 && res.data) {
          const openingDate = new Date(res.data.openingDate);
          const today = new Date();
          const daysSinceOpening = Math.floor((today - openingDate) / (1000 * 60 * 60 * 24));
          const daysUntilOneMonth = 30 - daysSinceOpening;

          this.batchStoreOpeningInfo = {
            openingDate: res.data.openingDate,
            daysSinceOpening: daysSinceOpening,
            daysUntilOneMonth: daysUntilOneMonth > 0 ? daysUntilOneMonth : 0,
            overOneMonth: daysSinceOpening > 30
          };
        } else {
          this.batchStoreOpeningInfo = null;
        }
      } catch (error) {
        console.error('获取门店开业时间失败：', error);
        this.batchStoreOpeningInfo = null;
      } finally {
        this.batchStoreOpeningLoading = false;
      }
    },
    // 文件选择变化
    handleFileChange(file, fileList) {
      this.batchGiftForm.file = file.raw;
      this.batchGiftForm.fileList = fileList;
      // 触发文件字段的验证
      if (this.$refs.batchGiftFormRef) {
        this.$refs.batchGiftFormRef.validateField('file');
      }
    },
    // 文件移除
    handleFileRemove() {
      this.batchGiftForm.file = null;
      this.batchGiftForm.fileList = [];
      // 触发文件字段的验证（显示必填错误）
      if (this.$refs.batchGiftFormRef) {
        this.$refs.batchGiftFormRef.validateField('file');
      }
    },
    // 下载模板
    async downloadTemplate() {
      try {
        const response = await this.$http.get('template/download', {
          params: {
            templateName: 'batch_gift_card'
          },
          responseType: 'blob'
        });
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '批量发卡模版.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
        this.$message.success('模板下载成功');
      } catch (error) {
        console.error('模板下载失败：', error);
        this.$message.error('模板下载失败');
      }
    },
    // 提交批量发卡
    async submitBatchGiftCard() {
      this.$refs.batchGiftFormRef.validate(async (valid) => {
        if (!valid) return;

        if (!this.batchGiftForm.file) {
          return this.$message.error('请选择导入文件');
        }

        this.batchGiftLoading = true;

        try {
          const formData = new FormData();
          formData.append('file', this.batchGiftForm.file);
          formData.append('storeid', this.batchGiftForm.storeid);
          formData.append('admin_token', window.sessionStorage.getItem('admin_token'));

          const { data: res } = await this.$http.post('giftcard/import', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });

          if (res.status === 0) {
            // 构建成功消息
            let successMsg = '批量发卡完成！';
            const details = [];

            if (res.successCount > 0) {
              details.push(`成功发卡 ${res.successCount} 张`);
            }
            if (res.skippedCount > 0) {
              details.push(`未注册用户 ${res.skippedCount} 个`);
            }

            if (details.length > 0) {
              successMsg += details.join('，');
            }

            this.$message.success(successMsg);
            this.batchGiftDialogVisible = false;
            this.getOrderList();
          } else {
            // 显示错误信息
            if (res.errors && res.errors.length > 0) {
              // 构建详细的错误消息
              let errorTitle = res.message || '批量发卡失败';

              // 添加统计信息
              const stats = [];
              if (res.successCount !== undefined) {
                stats.push(`成功：${res.successCount}`);
              }
              if (res.skippedCount !== undefined) {
                stats.push(`未注册：${res.skippedCount}`);
              }
              if (res.failedCount !== undefined) {
                stats.push(`失败：${res.failedCount}`);
              }

              if (stats.length > 0) {
                errorTitle += ` (${stats.join('，')})`;
              }

              const errorMsg = res.errors.join('\n');
              this.$alert(errorMsg, errorTitle, {
                confirmButtonText: '确定',
                type: 'warning',
                dangerouslyUseHTMLString: false
              });
            } else {
              this.$message.error(res.message || '批量发卡失败');
            }
          }
        } catch (error) {
          console.error('批量发卡失败：', error);
          this.$message.error('批量发卡失败：' + (error.message || '未知错误'));
        } finally {
          this.batchGiftLoading = false;
        }
      });
    },
    async fetchUsernames(query) {
      if (query === "" || query.length < 6) {
        // 至少输入6个字符才查询
        this.usernames = [];
        return;
      }
      this.loading = true;
      const { data: res } = await this.$http.get("getusernames/", {
        params: { query: query },
      });
      if (res.status == 0) {
        this.usernames = res.data;
      }
      this.loading = false;
    },
    async getCards(storeid) {
      const { data: res } = await this.$http.get(
        "cardsStore/?storeid=" + storeid
      );
      if (res.status == 0) {
        // 过滤掉不允许手动发放的卡类型：体验卡(3)、学生卡(4)、女神卡(5)、私教卡(7)
        this.cards = res.data.filter((card) =>
         card.cardclassid !== 2 && // 次卡
          card.cardclassid !== 3 && // 体验卡
          card.cardclassid !== 4 && // 学生卡
          card.cardclassid !== 5 && // 女神卡
          card.cardclassid !== 7 && // 私教卡
          card.cardclassid !== 9    // 早鸟卡
        ).map(card => ({
          ...card,
          // 确保包含显示需要的字段
          days: card.days || null,
          price: card.price || null,
          isActive: card.isActive !== undefined ? card.isActive : true
        }));
        console.log('获取到的卡片数据:', this.cards);
      }
    },

    // 选择常用短语
    selectPhrase(phrase) {
      this.giftForm.cardDescribe = phrase;
    },

    // 处理卡类型变化
    handleCardTypeChange(cardType) {
      // 清空相关字段
      this.giftForm.cityScope = [];
      this.giftForm.excludeStores = [];
      this.giftForm.cardid = null;

      // 设置istong值：time=0, city=2, national=1
      if (cardType === 'national') {
        this.giftForm.istong = '1';
      } else if (cardType === 'city') {
        this.giftForm.istong = '2';
      } else {
        this.giftForm.istong = '0';
      }

      if (cardType === 'national') {
        // 选择全国通卡时，自动选择"其他时效卡"，保留门店选择（作为发卡门店）
        this.giftForm.cardid = 'other_time_card';
        // 不清空storeid，全国通卡也需要发卡门店
      } else if (cardType === 'city') {
        // 选择城市通卡时，自动选择"其他时效卡"，保留门店选择
        this.giftForm.cardid = 'other_time_card';
      } else {
        // 选择时间卡时，重置卡片选择，清空城市选择
        const storeIds = Array.isArray(this.giftForm.storeid) ? this.giftForm.storeid : [];
        if (storeIds.length > 1) {
          // 多门店时只能选择"其他时效卡"
          this.giftForm.cardid = 'other_time_card';
        } else {
          this.giftForm.cardid = null;
        }
        this.giftForm.cityScope = [];
      }

      console.log('卡类型变化:', cardType, 'istong:', this.giftForm.istong, 'cardid:', this.giftForm.cardid);
    },
    async getStores() {
      const { data: res } = await this.$http.get("store/");
      if (res.status == 0) {
        this.stores = res.data;
        this.storeMap = new Map(this.stores.map((store) => [store.id, store.isopen]))
      }
    },
    // 手机号格式验证
    validatePhone(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入手机号"));
        return;
      }

      // 使用已有的多手机号验证方法
      const validation = this.validateMultiplePhones(value);
      if (!validation.valid) {
        callback(new Error(validation.message));
        return;
      }

      callback();
    },

    // 手机号输入事件（防抖处理）
    onPhoneInput(value) {
      // 清除上次的定时器
      if (this.phoneCheckTimer) {
        clearTimeout(this.phoneCheckTimer);
      }

      // 清除之前的状态
      this.phoneStatus = null;
      this.phoneFlag = false
      this.userCards = []; // 清空用户会员卡数据

      // 如果手机号为空或格式不正确，不检查
      if (!value) {
        return;
      }

      // 验证手机号格式
      const validation = this.isValidPhone(value);
      if (!validation) {
        return;
      }
      this.phoneFlag = true

      // 设置防抖延迟检查
      this.phoneCheckTimer = setTimeout(() => {
        this.checkPhoneStatus();
      }, 800); // 800ms防抖
    },

    // 手机号格式校验
    isValidPhone(phone) {
      const phoneRegex = /^1[3-9]\d{9}$/;
      return phoneRegex.test(phone);
    },

    // 解析多个手机号（逗号分隔）
    parsePhones(phoneInput) {
      if (!phoneInput || typeof phoneInput !== 'string') {
        return [];
      }

      // 按逗号分割，去除空格，过滤空值
      const phones = phoneInput.split(',')
        .map(phone => phone.trim())
        .filter(phone => phone.length > 0);

      return phones;
    },

    // 验证多个手机号格式
    validateMultiplePhones(phoneInput) {
      const phones = this.parsePhones(phoneInput);
      if (phones.length === 0) {
        return { valid: false, message: '请输入手机号' };
      }

      const invalidPhones = phones.filter(phone => !this.isValidPhone(phone));
      if (invalidPhones.length > 0) {
        return {
          valid: false,
          message: `手机号格式错误: ${invalidPhones.join(', ')}`
        };
      }

      return { valid: true, phones: phones };
    },

    // 检查手机号注册状态
    async checkPhoneStatus() {
      this.phoneFlag = false
      // 验证多个手机号格式
      const validation = this.isValidPhone(this.giftForm.phone);
      if (!validation) {
        this.phoneStatus = null;
        return;
      }
      this.phoneFlag = true

      const phones = [this.giftForm.phone];
      this.phoneCheckLoading = true;

      try {
        // 调用检查接口
        const { data: res } = await this.$http.post("checkPhoneRegistration/", {
          phones: phones,
        });

        if (res.status === 0 && res.data && res.data.length > 0) {
          // 如果是单个手机号，保持原有逻辑
          if (phones.length === 1) {
            this.phoneStatus = res.data[0]; // { phone, isRegistered, username }
            console.log("手机号检查结果:", this.phoneStatus);
          } else {
            // 多个手机号，存储所有状态信息
            this.phoneStatus = {
              isMultiple: true,
              phones: res.data,
              allRegistered: res.data.every(item => item.isRegistered),
              registeredCount: res.data.filter(item => item.isRegistered).length,
              unregisteredCount: res.data.filter(item => !item.isRegistered).length
            };
            console.log("多个手机号检查结果:", this.phoneStatus);
          }
        } else {
          // 如果接口返回异常，默认为未注册
          if (phones.length === 1) {
            this.phoneStatus = {
              phone: phones[0],
              isRegistered: false,
              username: null,
            };
          } else {
            this.phoneStatus = {
              isMultiple: true,
              phones: phones.map(phone => ({
                phone: phone,
                isRegistered: false,
                username: null
              })),
              allRegistered: false,
              registeredCount: 0,
              unregisteredCount: phones.length
            };
          }
        }
      } catch (error) {
        console.error("检查手机号状态失败:", error);
        // 错误时默认为未注册
        if (phones.length === 1) {
          this.phoneStatus = {
            phone: phones[0],
            isRegistered: false,
            username: null,
          };
        } else {
          this.phoneStatus = {
            isMultiple: true,
            phones: phones.map(phone => ({
              phone: phone,
              isRegistered: false,
              username: null
            })),
            allRegistered: false,
            registeredCount: 0,
            unregisteredCount: phones.length
          };
        }
      } finally {
        this.phoneCheckLoading = false;
      }
    },

    // 查询用户会员卡
    async queryUserCards() {
      if (!this.phoneStatus || !this.phoneStatus.isRegistered) {
        this.$message.warning('请先输入已注册用户的手机号');
        return;
      }

      this.userCardsLoading = true;
      this.userCards = [];

      try {
        const { data: res } = await this.$http.get(`usercards/?username=${this.phoneStatus.username}`);

        if (res.status === 0) {
          this.userCards = res.data || [];
          if (this.userCards.length === 0) {
            this.$message.info('该用户暂无会员卡记录');
          } else {
            this.$message.success(`查询成功，找到${this.userCards.length}张会员卡`);
          }
        } else {
          this.$message.error(res.message || '查询用户会员卡失败');
        }
      } catch (error) {
        console.error('查询用户会员卡失败:', error);
        this.$message.error('查询失败，请重试');
      } finally {
        this.userCardsLoading = false;
      }
    },

    async SaveGiftCard() {
      this.$refs.giftFormRef.validate(async (valid) => {
        if (!valid) return;

        if (!this.phoneFlag) {
          this.$message.error("手机号格式异常");
          return;
        }
        // 检查手机号状态
        if (!this.phoneStatus) {
          this.$message.error("请等待手机号状态检查完成");
          return;
        }

        // 已选发卡门店ID列表
        const giftStoreIds = Array.isArray(this.giftForm.storeid) ? this.giftForm.storeid : (this.giftForm.storeid ? [this.giftForm.storeid] : []);
        const isMultiStore = giftStoreIds.length > 1;

        // 时间卡和城市通卡都需要选择门店
        if ((this.giftForm.cardType === 'time' || this.giftForm.cardType === 'city') && giftStoreIds.length === 0) {
          this.$message.error("请选择门店");
          return;
        }

        // 城市通卡需要选择城市
        if (this.giftForm.cardType === 'city' && (!this.giftForm.cityScope || this.giftForm.cityScope.length === 0)) {
          this.$message.error("请选择城市");
          return;
        }

        // 城市通卡验证：单门店时门店必须在所选城市内（多门店仅限其他时效卡，不做此校验）
        if (this.giftForm.cardType === 'city' && giftStoreIds.length === 1) {
          const selectedStore = this.stores.find(s => s.id === giftStoreIds[0]);
          if (selectedStore && !this.giftForm.cityScope.includes(selectedStore.city)) {
            this.$message.error(`所选门店"${selectedStore.storename}"不在所选城市范围内，该门店所属城市为"${selectedStore.city}"`);
            return;
          }
        }

        // 验证天数（当选择其他时效卡时）
        if (this.giftForm.cardid === 'other_time_card') {
          if (!this.giftForm.days || this.giftForm.days <= 0) {
            this.$message.error("请输入有效的天数");
            return;
          }
        }

        // 这部分逻辑已经在上面处理过，不需要重复验证

        this.giftLoading = true; // 开始发卡，显示loading

        try {
          let res;

          // 处理多个手机号的情况
          if (this.phoneStatus.isMultiple) {
            // 多个手机号发卡（都是已注册用户）
            console.log("多个已注册用户，使用接口 /giftcard/");

            const usernames = this.phoneStatus.phones
              .filter(phone => phone.isRegistered)
              .map(phone => phone.username);

            const requestData = {
              username: usernames, // 多个用户名数组
              storeid: isMultiStore ? "" : giftStoreIds[0],
              storeidlist: isMultiStore ? giftStoreIds : [],
              cardid: this.giftForm.cardid,
              admin_token: window.sessionStorage.getItem("admin_token"),
              cardDescribe: this.giftForm.cardDescribe || "手动发卡",
              startDate: this.giftForm.startDate
            };

            // 选择其他时效卡时，添加days参数和卡类型参数
            if (this.giftForm.cardid === 'other_time_card') {
              requestData.days = parseInt(this.giftForm.days);
              requestData.cardclassid = 8;
              requestData.cardid = 0;
            }

            // 设置istong值
            requestData.istong = this.giftForm.istong;

            // 城市通卡时，传递城市列表作为scope
            if (this.giftForm.cardType === 'city' && this.giftForm.cityScope.length > 0) {
              requestData.scope = this.giftForm.cityScope.join(',');
              // 传递排除的门店ID列表
              if (this.giftForm.excludeStores && this.giftForm.excludeStores.length > 0) {
                requestData.excludeStores = this.giftForm.excludeStores.join(',');
              }
            }

            console.log("发送给接口的数据（多用户）:", requestData);
            console.log("准备调用后端接口 /giftcard/");
            const response = await this.$http.post("giftcard/", requestData);
            console.log("后端接口返回:", response);
            res = response.data;
          } else if (this.phoneStatus.isRegistered) {
            // 单个注册用户：直接发卡到用户账户
            console.log("单个已注册用户，使用接口 /giftcard/");

            const requestData = {
              username: [this.phoneStatus.username], // 数组格式
              storeid: isMultiStore ? "" : giftStoreIds[0],
              storeidlist: isMultiStore ? giftStoreIds : [],
              cardid: this.giftForm.cardid,
              admin_token: window.sessionStorage.getItem("admin_token"),
              cardDescribe: this.giftForm.cardDescribe || "手动发卡",
              startDate: this.giftForm.startDate
            };

            // 选择其他时效卡时，添加days参数和卡类型参数
            if (this.giftForm.cardid === 'other_time_card') {
              requestData.days = parseInt(this.giftForm.days);
              requestData.cardclassid = 8;
              requestData.cardid = 0;
            }

            // 设置istong值
            requestData.istong = this.giftForm.istong;

            // 城市通卡时，传递城市列表作为scope
            if (this.giftForm.cardType === 'city' && this.giftForm.cityScope.length > 0) {
              requestData.scope = this.giftForm.cityScope.join(',');
              // 传递排除的门店ID列表
              if (this.giftForm.excludeStores && this.giftForm.excludeStores.length > 0) {
                requestData.excludeStores = this.giftForm.excludeStores.join(',');
              }
            }

            console.log("发送给接口的数据（单用户）:", requestData);
            console.log("准备调用后端接口 /giftcard/");
            const response = await this.$http.post("giftcard/", requestData);
            console.log("后端接口返回:", response);
            res = response.data;
          } else {
            // 单个未注册用户：创建赠卡记录
            console.log("未注册用户，使用接口 /giftcard/create");

            const requestData = {
              receiverPhone: this.giftForm.phone,
              cardId: this.giftForm.cardid,
              storeId: isMultiStore ? "" : giftStoreIds[0],
              storeIdlist: isMultiStore ? giftStoreIds : [],
              remark: this.giftForm.cardDescribe || "手动发卡",
            };

            if (this.giftForm.cardid === 'other_time_card') {
              requestData.cardId = 0;
              requestData.days = parseInt(this.giftForm.days);
            }

            console.log("发送给接口的数据（未注册）:", requestData);
            const response = await this.$http.post("giftcard/create", requestData);
            res = response.data;
          }

          if (res.status === 0) {
            this.$message.success("发卡成功");
            this.giftDialogVisible = false;
            this.getOrderList();
          } else {
            this.$message.error(res.error || "发卡失败");
          }
        } catch (error) {
          console.error("发卡失败:", error);
          if (error.response && error.response.status === 401) {
            this.$message.error("登录已过期，请重新登录");
          } else {
            this.$message.error("发卡失败，请重试");
          }
        } finally {
          this.giftLoading = false; // 发卡完成，隐藏loading
        }
      });
    },
    getSummaries(param) {
      this.$nextTick(() => {
        this.$refs.invoiceTable.doLayout(); // invoiceTable替换为你的el-table设置的ref值
      });
      // console.log(param);
      const { columns, data } = param;
      const sums = [];

      columns.forEach((column, index) => {
        // 如果是第一列，显示 "总价"
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        // 只计算 `amount` 列的合计
        if (column.property === "amount") {
          const values = data.map((item) => Number(item[column.property]));
          let total = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + value; // 累加合计值
            } else {
              return prev;
            }
          }, 0);
          sums[index] = `${total.toFixed(1)} 元`; // 保留一位小数后加单位
        } else {
          sums[index] = ""; // 非 `amount` 列不显示合计
        }
      });

      return sums;
    },
    // 导出订单数据
    exportOrders() {
      // 门店/日期条件二选一：至少填写一个条件即可导出
      const hasStore = !!this.queryInfo.query1
      const hasDate = !!this.queryInfo.startdate && !!this.queryInfo.enddate
      if (!hasStore && !hasDate) {
        this.$message.warning('请选择门店或日期范围（至少填写一个条件）')
        return
      }
      let downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axios
        .get("/orderAllList/export", {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          responseType: "blob",
          params: this.queryInfo,
        })
        .then(async (data) => {
          const isBlob = data.data.type !== "application/json";
          if (isBlob) {
            const blob = new Blob([data.data]);
            saveAs(blob, `订单数据_${new Date().getTime()}.xlsx`);
          } else {
            this.$message.error("导出订单数据失败");
          }
          downloadLoadingInstance.close();
        })
        .catch((r) => {
          console.error(r);
          this.$message.error("下载文件出现错误，请联系管理员！");
          downloadLoadingInstance.close();
        });
    },
    // 同步会员卡
    synCard() {
      let downloadLoadingInstance = Loading.service({
        text: "同步会员卡中，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axios
        .get("/syncCard")
        .then(async (data) => {
          console.log(data)
          if (data.status == 0) {
            this.$message.error("同步成功！");
          }
          downloadLoadingInstance.close();
        })
        .catch((r) => {
          console.error(r);
          this.$message.error("同步失败！");
          downloadLoadingInstance.close();
        });
    },
    // 导出订单数据
    exportOrders2() {
      let downloadLoadingInstance = Loading.service({
        text: "正在下载数据，请稍候",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axios
        .get("/refundExcel/", {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          responseType: "blob",
        })
        .then(async (data) => {
          const isBlob = data.data.type !== "application/json";
          if (isBlob) {
            const blob = new Blob([data.data]);
            saveAs(blob, `退款数据_${new Date().getTime()}.xlsx`);
          } else {
            this.$message.error("导出退款数据失败");
          }
          downloadLoadingInstance.close();
        })
        .catch((r) => {
          console.error(r);
          this.$message.error("下载文件出现错误，请联系管理员！");
          downloadLoadingInstance.close();
        });
    },
    async Refund(id, amount) {
      // 获取订单详情
      const { data: res } = await this.$http.get(`order/detail/${id}`);
      if (res.code !== 200) {
        return this.$message.error("获取订单信息失败");
      }

      // 设置退款表单数据
      this.refundForm = {
        id: id,
        amount: amount || 0,
        refundamount: "",
        refunddescribe: "",
        cardfrom: res.data.cardfrom || "",
      };

      // 如果是抖音、美团或高德，自动设置退款金额为最大金额
      if (res.data.cardfrom == "1" || res.data.cardfrom == "2" || res.data.cardfrom == "7") {
        this.refundForm.refundamount = amount || 0;
      }

      this.refundDialogVisible = true;
    },
    refundDialogClosed() {
      this.$refs.refundFormRef.resetFields();
      this.refundLinkInfo = null;
      // 重置退款表单
      this.refundForm = {
        id: "",
        amount: 0,
        syAmount: 0,
        refundamount: "",
        refunddescribe: "",
        cardfrom: "",
        starttime: "",
        endtime: "",
        username: "",
        shouldCharge: 0.00,
      };
      // 重置到店天数信息
      this.visitDaysInfo = {
        visitDays: 0,
        unitPrice: "19",
        details: [],
        showDetails: false,
      };
    },

    // 处理中文输入法结束事件
    handleCompositionEnd(e) {
      // 中文输入法完成后立即验证
      this.validateRefundAmount();
    },

    // 处理中文输入法结束事件
    handleCompositionEndShould(e) {
      // 中文输入法完成后立即验证
      this.validateShouldAmount();
    },

    // 处理粘贴事件
    handlePaste(e) {
      // 阻止默认粘贴行为
      e.preventDefault();

      // 获取粘贴的文本
      const pastedText = (e.clipboardData || window.clipboardData).getData(
        "text"
      );

      // 只允许粘贴数字和小数点
      const validText = pastedText.replace(/[^\d.]/g, "");

      // 处理小数点
      let parts = validText.split(".");
      let result = parts[0];
      if (parts.length > 1) {
        result += "." + parts[1].substring(0, 2); // 只保留小数点后两位
      }

      // 将处理后的文本插入到当前值中
      const currentValue = this.refundForm.refundamount || "";
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;

      this.refundForm.refundamount =
        currentValue.substring(0, selectionStart) +
        result +
        currentValue.substring(selectionEnd);

      // 立即验证
      this.validateRefundAmount();
    },

    // 处理粘贴事件
    handlePasteShould(e) {
      // 阻止默认粘贴行为
      e.preventDefault();

      // 获取粘贴的文本
      const pastedText = (e.clipboardData || window.clipboardData).getData(
        "text"
      );

      // 只允许粘贴数字和小数点
      const validText = pastedText.replace(/[^\d.]/g, "");

      // 处理小数点
      let parts = validText.split(".");
      let result = parts[0];
      if (parts.length > 1) {
        result += "." + parts[1].substring(0, 2); // 只保留小数点后两位
      }

      // 将处理后的文本插入到当前值中
      const currentValue = this.refundForm.shouldCharge || "";
      const selectionStart = e.target.selectionStart;
      const selectionEnd = e.target.selectionEnd;

      this.refundForm.shouldCharge =
        currentValue.substring(0, selectionStart) +
        result +
        currentValue.substring(selectionEnd);

      // 立即验证
      this.validateShouldAmount();
    },

    // 检查键盘输入，只允许输入数字和小数点
    checkNumberInput(e) {
      // 只允许数字和小数点
      const charCode = e.which ? e.which : e.keyCode;

      // 如果输入的不是数字且不是小数点，阻止输入
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        e.preventDefault();
        return false;
      }

      // 如果已经有小数点了，不允许再输入小数点
      if (charCode === 46 && this.refundForm.refundamount.includes(".")) {
        e.preventDefault();
        return false;
      }

      return true;
    },

    // 检查键盘输入，只允许输入数字和小数点
    checkNumberInputShould(e) {
      // 只允许数字和小数点
      const charCode = e.which ? e.which : e.keyCode;

      // 如果输入的不是数字且不是小数点，阻止输入
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        e.preventDefault();
        return false;
      }

      // 如果已经有小数点了，不允许再输入小数点
      if (charCode === 46 && this.refundForm.shouldCharge.includes(".")) {
        e.preventDefault();
        return false;
      }

      return true;
    },

    // 验证退款金额，确保只能输入数字且不超过订单金额
    validateRefundAmount() {
      // 如果是抖音、美团或高德订单，退款金额固定为订单金额
      if (this.refundForm.cardfrom == "1" || this.refundForm.cardfrom == "2" || this.refundForm.cardfrom == "7") {
        this.refundForm.refundamount = this.refundForm.amount;
        return;
      }

      // 去除非数字字符
      this.refundForm.refundamount = this.refundForm.refundamount.replace(
        /[^\d.]/g,
        ""
      );

      // 确保只有一个小数点
      const parts = this.refundForm.refundamount.split(".");
      if (parts.length > 2) {
        this.refundForm.refundamount = parts[0] + "." + parts.slice(1).join("");
      }

      // 确保小数点后最多两位
      if (parts.length === 2 && parts[1].length > 2) {
        this.refundForm.refundamount =
          parts[0] + "." + parts[1].substring(0, 2);
      }

      // 如果输入的金额大于订单金额，自动设置为订单金额
      if (
        this.refundForm.refundamount &&
        Number(this.refundForm.refundamount) > Number(this.refundForm.syAmount)
      ) {
        this.refundForm.refundamount = this.refundForm.syAmount;
        this.$message.info("退款金额不能超过订单金额，已自动调整为订单可退金额");
      }
    },

    // 验证应收金额，确保只能输入数字且不超过订单金额
    validateShouldAmount() {
      // 去除非数字字符
      this.refundForm.shouldCharge = this.refundForm.shouldCharge.replace(
        /[^\d.]/g,
        ""
      );

      // 确保只有一个小数点
      const parts = this.refundForm.shouldCharge.split(".");
      if (parts.length > 2) {
        this.refundForm.shouldCharge = parts[0] + "." + parts.slice(1).join("");
      }

      // 确保小数点后最多两位
      if (parts.length === 2 && parts[1].length > 2) {
        this.refundForm.shouldCharge =
          parts[0] + "." + parts[1].substring(0, 2);
      }

      // 如果输入的金额大于订单金额，自动设置为订单金额
      if (
        this.refundForm.shouldCharge &&
        Number(this.refundForm.shouldCharge) > Number(this.refundForm.syAmount)
      ) {
        this.refundForm.shouldCharge = this.refundForm.syAmount;
        this.$message.info("应收金额不能超过订单金额，已自动调整为订单可退金额");
      }
    },

    // 计算不含税金额（除以1.06，保留2位小数）
    calculateTaxFreeAmount(amount) {
      if (!amount || amount === '') {
        return '0.00';
      }
      const taxFreeAmount = Number(amount) / 1.06;
      return taxFreeAmount.toFixed(2);
    },

    // 一键应用计算后的不含税金额
    applyTaxFreeAmount() {
      const taxFreeAmount = this.calculateTaxFreeAmount(this.refundForm.refundamount);
      this.refundForm.refundamount = taxFreeAmount;
      this.$message.success(`已应用计算结果：${taxFreeAmount} 元`);
    },

    // 查询到店天数
    async fetchVisitDays(username, starttime, endtime, amount) {
      if (!username || !starttime || !endtime) {
        return;
      }
      this.visitDaysLoading = true;
      try {
        const { data: res } = await this.$http.get('order/visit-days', {
          params: {
            username: username,
            startDate: starttime,
            endDate: endtime,
          }
        });
        if (res.code === 200 && res.data) {
          this.visitDaysInfo.visitDays = res.data.visitDays || 0;
          this.visitDaysInfo.details = res.data.details || [];
          this.calcRefundAmount();
        }
      } catch (error) {
        console.error('查询到店天数失败:', error);
      } finally {
        this.visitDaysLoading = false;
      }
    },

    // 计算应收金额
    calcRefundAmount() {
      const days = Number(this.refundForm.openDays) || 0;
      const price = Number(this.visitDaysInfo.unitPrice) || 0;
      this.refundForm.shouldCharge = (days * price).toFixed(2);
      if (this.refundType == 0 && this.refundForm.shouldCharge > this.refundForm.syAmount) {
        this.refundForm.shouldCharge = this.refundForm.syAmount
      }
    },

    // 删卡方法，打开退款对话框
    async DelCard(row) {
      if (row.fzOrderNo) {
        if (row.fzStatus == 'PROCESSING' || row.fzStatus == 'PENDING_RETRY') {
          return this.$message.warning('小程序订单还在分账中，请稍后再进行退款');
        } else if (row.fzStatus == 'JD_ERROR') {
          return this.$message.warning('该订单解冻失败，请记录联系技术进行退款');
        }
      }

      // 设置退款对话框数据
      this.refundForm = {
        id: row.id,
        amount: row.amount || 0, // 订单金额
        syAmount: parseFloat((row.amount || 0) - (row.refundamount || 0)).toFixed(2), //剩余可退金额
        refundamount: parseFloat((row.amount || 0) - (row.refundamount || 0)).toFixed(2), // 退款金额，用户输入
        refunddescribe: "", // 退款说明，用户输入
        cardfrom: row.cardfrom, // 来源
        doutuireason: row.doutuireason || "", // 抖音退款原因
        rejectreason: row.rejectreason || "",
        starttime: row.starttime || "", // 卡开始时间
        endtime: row.endtime || "", // 卡结束时间
        username: row.username || "", // 用户手机号
        openDays: this.getDaysDiff(row.starttime, new Date()),
        shouldCharge: 0.00
      };

      this.refundType = 0

      // 重置到店天数信息
      this.visitDaysInfo = {
        visitDays: 0,
        unitPrice: "19",
        shouldCharge: "0.00",
        details: [],
        showDetails: false,
      };

      // 如果是抖音、美团或高德，自动设置退款金额为最大金额
      if (row.cardfrom == "1" || row.cardfrom == "2" || row.cardfrom == "7") {
        this.refundForm.refundamount = row.amount || 0;
      }

      // 显示退款对话框
      this.refundDialogVisible = true;
      this.getRefundLinkInfo(row.storeid);

      // 查询到店天数
      this.fetchVisitDays(row.username, row.starttime, row.endtime, row.amount);
    },
    refundLinkContactText(info) {
      if (!info) return "";
      const link = info.refundLink || info.refund_link;
      return link ? String(link).trim() : "";
    },
    getRefundLinkInfo(storeId) {
      if (!storeId) {
        this.refundLinkInfo = null;
        return;
      }
      this.$http
        .get("storerefundlinkbystore/" + storeId)
        .then(({ data: res }) => {
          if ((res.code === 0 || res.status === 0) && res.data) {
            const data = res.data;
            this.refundLinkInfo = {
              ...data,
              refundLink: data.refundLink || data.refund_link || "",
            };
          } else {
            this.refundLinkInfo = null;
          }
        })
        .catch(() => {
          this.refundLinkInfo = null;
        });
    },
    async CopyCard(row) {
      this.copyStores = this.stores.filter(item => item.id != row.storeid);
      this.copyForm.id = row.id;
      this.copyForm.createBy = this.username;
      this.copyForm.storeid = null
      this.copyDialogVisible = true;
    },

    // 提交复制
    async submitCopy() {
      // 验证表单
      this.$refs.copyFormRef.validate(async (valid) => {
        if (!valid) return;

        // 再次确认
        const confirmResult = await this.$confirm(
          "确定要将当前会员卡复制到选择的店铺么？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).catch((err) => err);

        if (confirmResult !== "confirm") {
          return this.$message.info("已取消复制！");
        }

        const { data: res } = await this.$http.post("ordercopy/", this.copyForm);
        if (res.code === 200) {
          this.$message({ message: "复制成功！", type: "success" });
          // 关闭对话框
          this.copyDialogVisible = false;
          // 刷新列表
          this.getOrderList();
        } else {
          this.$message({ message: res.msg || "复制失败！", type: "error" });
        }
      });
    },

    // 提交退款
    async submitRefund() {
      // 验证表单
      this.$refs.refundFormRef.validate(async (valid) => {
        if (!valid) return;

        // 再次确认
        const confirmResult = await this.$confirm(
          "确定要对此订单进行退款吗？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).catch((err) => err);

        if (confirmResult !== "confirm") {
          return this.$message.info("已取消退款！");
        }

        // 检查是否填写了退款说明
        if (
          !this.refundForm.refunddescribe ||
          this.refundForm.refunddescribe.trim() === ""
        ) {
          return this.$message.error("请填写退款说明");
        }

        if (this.refundForm.cardfrom == '0' && this.refundForm.refundamount < 1) {
          return this.$message.error("退款金额最少1元");
        }

        if (this.refundForm.shouldCharge < 1 && this.refundType == 0) {
          return this.$message.error("应收金额最小1元");
        }

        // 使用用户输入的退款说明
        let refundDesc = this.refundForm.refunddescribe;


        // 发送退款请求
        const admin_token = window.sessionStorage.getItem("admin_token");
        const { data: res } = await this.$http.post("orderdel/", {
          admin_token: admin_token,
          id: this.refundForm.id,
          refundamount: this.refundForm.refundamount,
          refunddescribe: refundDesc,
          refundType: this.refundType,
          shouldCharge: this.refundForm.shouldCharge,
          audit_status: true, // 同意退款
        });

        if (res.code === 200) {
          this.$message({ message: res.msg, type: "success" });
          // 关闭对话框
          this.refundDialogVisible = false;
          // 刷新列表
          this.getOrderList();
        } else {
          this.$message({ message: res.msg || "退款失败！", type: "error" });
        }
      });
    },

    // 拒绝退款
    async rejectRefund() {
      // 验证表单
      this.$refs.refundFormRef.validate(async (valid) => {
        if (!valid) return;

        // 检查是否填写了拒绝原因
        if (
          !this.refundForm.rejectreason ||
          this.refundForm.rejectreason.trim() === ""
        ) {
          return this.$message.error("请填写拒绝原因");
        }

        // 再次确认
        const confirmResult = await this.$confirm(
          "确定要拒绝此订单的退款申请吗？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).catch((err) => err);

        if (confirmResult !== "confirm") {
          return this.$message.info("已取消操作！");
        }

        // 发送拒绝退款请求
        const admin_token = window.sessionStorage.getItem("admin_token");
        const { data: res } = await this.$http.post("orderdel/", {
          admin_token: admin_token,
          id: this.refundForm.id,
          refundamount: "0", // 拒绝退款时金额设置为0
          rejectreason: this.refundForm.rejectreason, // 使用拒绝原因字段
          audit_status: false, // 拒绝退款
        });

        if (res.code === 200) {
          this.$message({ message: "已拒绝退款申请！", type: "success" });
          // 关闭对话框
          this.refundDialogVisible = false;
          // 刷新列表
          this.getOrderList();
        } else {
          this.$message({ message: res.msg || "操作失败！", type: "error" });
        }
      });
    },
    // 设置表格行的类名
    tableRowClassName({ row }) {
      // 同时满足 doutuiflag=1 和 status=0 的条件才显示浅红色背景
      if (row.doutuiflag == 1 && row.status == 0) {
        return "doutuiflag-row";
      }
      return "";
    },
    handleStoreAlter(val) {
      this.cards = [];
      this.storeOpeningInfo = null; // 清空之前的开业时间信息
      const storeIds = Array.isArray(val) ? val : (val ? [val] : []);
      if (storeIds.length === 1) {
        // 单门店：保持原有功能，加载该门店的会员卡和开业时间
        this.getCards(storeIds[0]);
        this.getStoreOpeningTime(storeIds[0]); // 获取门店开业时间信息
      } else if (storeIds.length > 1) {
        this.giftForm.startDate = null
        // 多门店：会员卡只能选择"其他时效卡"
        this.giftForm.cardid = 'other_time_card';
        // 多门店时隐藏城市通卡/全国通卡，切回时间卡
        if (this.giftForm.cardType !== 'time') {
          this.giftForm.cardType = 'time';
          this.giftForm.cityScope = [];
        }
      }
    },

    // 获取门店开业时间信息
    async getStoreOpeningTime(storeId) {
      if (!storeId) {
        return;
      }

      this.storeOpeningLoading = true;
      try {
        const { data: res } = await this.$http.get(`api/store/opening-time/${storeId}`);

        if (res.code === 200 && res.data) {
          this.storeOpeningInfo = res.data;

          // 显示提示信息
          if (this.storeOpeningInfo.overOneMonth) {
            // 超过一个月，强烈提示
            this.$notify({
              title: '⚠️ 重要提示',
              message: `该门店已开业 ${this.storeOpeningInfo.daysSinceOpening} 天（开业日期：${this.storeOpeningInfo.openingDate}），请谨慎发放时效卡！`,
              type: 'warning',
              duration: 8000,
              position: 'top-right'
            });
          } else {
            // 未超过一个月，微弱提示
            const daysRemaining = this.storeOpeningInfo.daysUntilOneMonth;
            this.$message({
              message: `该门店已开业 ${this.storeOpeningInfo.daysSinceOpening} 天，距离一个月还有 ${daysRemaining} 天`,
              type: 'info',
              duration: 5000
            });
          }
        }
      } catch (error) {
        console.error('获取门店开业时间失败:', error);
        // 静默失败，不影响正常发卡流程
      } finally {
        this.storeOpeningLoading = false;
      }
    },
    handleTypeAlter(val) {
      if (val === "0") {
        // 按卡发放，不需要天数
        this.giftForm.days = null;
        this.giftFormRules.days = [
          { required: false, message: "请输入天数", trigger: "blur" },
        ];
        if (this.giftForm.storeid != null) {
          this.cards = [];
          const storeIds = Array.isArray(this.giftForm.storeid) ? this.giftForm.storeid : [this.giftForm.storeid];
          if (storeIds.length === 1) {
            this.getCards(storeIds[0]);
          }
        }
      } else {
        // 按时长发放，默认使用赠送时长卡，卡类型为8（其他）
        this.giftForm.cardid = 0; // 设置card_price_id为0
        this.giftFormRules.days = [
          { required: true, message: "请输入时长", trigger: "blur" },
          { pattern: /^\d{1,3}$/, message: "天数必须为1-999的整数", trigger: "blur" },
        ];
      }
    },
    handleCardChange(val) {
      if (val === 0) {
        // 选择了"其他时效卡"，需要显示天数输入框
        this.giftFormRules.days = [
          { required: true, message: "请输入天数", trigger: "blur" },
          { pattern: /^\d{1,3}$/, message: "天数必须为1-999的整数", trigger: "blur" },
        ];
        this.giftForm.days = null; // 清空天数，让用户手动输入
      } else {
        // 选择了普通卡片，获取卡片原有的天数
        const selectedCard = this.cards.find(card => card.id === val);
        if (selectedCard && selectedCard.days) {
          this.giftForm.days = selectedCard.days;
        } else {
          this.giftForm.days = null;
        }
        // 移除天数验证规则
        this.giftFormRules.days = [];
      }
    },
    // 城市选择变化时，清空排除门店列表
    handleCityScopeChange() {
      // 当城市选择变化时，清空已选择的排除门店
      this.giftForm.excludeStores = [];
    },

    // 显示赠卡记录对话框
    showGiftCardRecords() {
      this.giftRecordDialogVisible = true;
      this.getGiftCardRecords();
    },

    // 获取赠卡记录列表
    async getGiftCardRecords() {
      this.giftRecordLoading = true;
      try {
        const params = {
          receiverPhone: this.giftRecordQuery.receiverPhone || null,
          storeId: this.giftRecordQuery.storeId || null,
          isClaimed: this.giftRecordQuery.isClaimed !== "" ? this.giftRecordQuery.isClaimed : null,
          pagenum: this.giftRecordQuery.pagenum,
          pagesize: this.giftRecordQuery.pagesize,
        };

        const { data: res } = await this.$http.post("giftcard/list", params);

        if (res.status === 0) {
          this.giftRecordList = res.data || [];
          this.giftRecordTotal = res.count || 0;
        } else {
          this.$message.error(res.msg || "获取赠卡记录失败");
          this.giftRecordList = [];
          this.giftRecordTotal = 0;
        }
      } catch (error) {
        console.error("获取赠卡记录失败:", error);
        this.$message.error("获取赠卡记录失败");
        this.giftRecordList = [];
        this.giftRecordTotal = 0;
      } finally {
        this.giftRecordLoading = false;
      }
    },

    // 重置查询条件
    resetGiftRecordQuery() {
      this.giftRecordQuery = {
        receiverPhone: "",
        storeId: "",
        isClaimed: "",
        pagenum: 1,
        pagesize: 20,
      };
      this.getGiftCardRecords();
    },

    // 分页大小改变
    handleGiftRecordSizeChange(newSize) {
      this.giftRecordQuery.pagesize = newSize;
      this.giftRecordQuery.pagenum = 1;
      this.getGiftCardRecords();
    },

    // 当前页改变
    handleGiftRecordCurrentChange(newPage) {
      this.giftRecordQuery.pagenum = newPage;
      this.getGiftCardRecords();
    },

    // 删除赠卡记录
    async deleteGiftCardRecord(id) {
      try {
        const confirmResult = await this.$confirm(
          "确定要删除这条赠卡记录吗？删除后无法恢复！",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );

        if (confirmResult !== "confirm") return;

        const { data: res } = await this.$http.delete(`giftcard/delete/${id}`);

        if (res.status === 0) {
          this.$message.success("删除成功");
          this.getGiftCardRecords(); // 刷新列表
        } else {
          this.$message.error(res.msg || "删除失败");
        }
      } catch (error) {
        if (error === "cancel") {
          this.$message.info("已取消删除");
        } else {
          console.error("删除赠卡记录失败:", error);
          this.$message.error("删除失败");
        }
      }
    },
    // 关闭赠卡记录对话框
    giftRecordDialogClosed() {
      // 重置查询条件
      this.resetGiftRecordQuery();
    },
    // 退款类型变更事件
    handleRefund(val) {
      this.visitDaysInfo.unitPrice = 19
      this.calcRefundAmount()
      if (val == 0 || this.refundForm.cardfrom == "1" || this.refundForm.cardfrom == "2" || this.refundForm.cardfrom == "7") {
        this.refundForm.refundamount = this.refundForm.syAmount

        if (val == 0) {
          this.refundFormRules.shouldCharge = [
            { required: true, message: "请输入应收金额", trigger: "blur" },
            {validator: (rule, value, callback) => {
                if (value === "") {
                  callback(new Error("请输入应收金额"));
                } else if (isNaN(value)) {
                  callback(new Error("应收金额必须是数字"));
                } else if (parseFloat(value) <= 0) {
                  callback(new Error("应收金额必须大于0"));
                } else if (
                    parseFloat(value) > parseFloat(this.refundForm.amount)
                ) {
                  callback(new Error("应收金额不能超过订单金额"));
                } else {
                  callback();
                }
              },
              trigger: "blur",
            }
          ]
        }
      } else {
        this.refundForm.refundamount = 0
        this.refundFormRules.shouldCharge = []
      }
    },
    // 计算日期相差天数
    getDaysDiff(date1, date2) {
      if (date1 && date2) {
        if (new Date(date1) > date2) {
          return 0
        }
        const msPerDay = 24 * 60 * 60 * 1000;
        const start = new Date(new Date(date1).setHours(0, 0, 0, 0));
        const end = new Date(new Date(date2).setHours(0, 0, 0, 0));

        return Math.round((end - start) / msPerDay) + 1;
      }
      return 0;
    }
  },
};
</script>
<style scoped>
.cardcss {
  margin: 5px auto;
  width: 100%;
}
.el-breadcrumb {
  width: 100%;
}
</style>

<!-- 全局样式，不使用scoped，确保可以影响el-table内部元素 -->
<style>
/* 允许表格内容被选择和复制 */
.el-table {
  user-select: text !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
}

.el-table__body-wrapper {
  user-select: text !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
}

.el-table__body tr,
.el-table__body td {
  user-select: text !important;
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
}

/* doutuiflag=1且status=0的行显示浅红色背景 */
.el-table .doutuiflag-row {
  background-color: #ffebeb !important;
}

/* 鼠标悬停时的样式 */
.el-table .doutuiflag-row:hover > td {
  background-color: #ffe0e0 !important;
}

/* 时效卡弹窗样式 */
.gift-card-dialog .el-dialog__header {
  background-color: #f56c6c;
  padding: 15px 20px;
}

.gift-card-dialog .el-dialog__title {
  color: white;
  font-weight: bold;
}

/* 赠卡记录弹窗样式 */
.gift-record-dialog .el-dialog__header {
  background-color: #409eff;
  padding: 15px 20px;
}

.gift-record-dialog .el-dialog__title {
  color: white;
  font-weight: bold;
  font-size: 18px;
}

.gift-card-dialog .el-dialog__body {
  padding: 30px 20px;
}

.gift-card-dialog .el-button--primary {
  background-color: #f56c6c;
  border-color: #f56c6c;
}

.gift-card-dialog .el-button--primary:hover,
.gift-card-dialog .el-button--primary:focus {
  background-color: #f78989;
  border-color: #f78989;
}

.gift-card-dialog .duration-input .el-input__inner:focus {
  border-color: #f56c6c;
}

/* 其他时效卡选项样式 */
.el-select-dropdown__item.other-time-card {
  color: #f56c6c;
  font-weight: bold;
}

.el-select-dropdown__item.other-time-card.selected {
  color: #fff;
  background-color: #f56c6c;
}

.reFoundContainer{
  display: flex;align-items: baseline; margin-bottom: 22px;
  .label{
    padding-right: 12px;
    width: 88px;
    text-align: right;
    line-height: 40px;
  }
}
</style>
